import React, {
  useEffect,
  useRef,
  useState,
  useCallback,
  useMemo,
} from "react";
import { Row, Col, Form, Button, Table, Modal, Spinner } from "react-bootstrap";
import { Link, useNavigate, useBlocker } from "react-router-dom";
import axios from "axios";
import { OverlayTrigger, Tooltip as BSTooltip } from "react-bootstrap";
import { IoEyeOutline } from "react-icons/io5";
import { ErrorMessage, FieldArray, Formik } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import { IconButton, Tooltip, Box, TextField, Checkbox } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import CancelIcon from "@mui/icons-material/Cancel";
import FocusError from "../../../components/error/error-focus";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import FadeLoaderComponent from "../../../components/loader-component";
import ProductAddModel from "./product-add-model";
import { BsCaretUpFill, BsCaretDownFill } from "react-icons/bs";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";
import { roleTypes } from "../../../data/roleType";
import DatePickerField from "../../../components/input/date-picker-field";
import { Plus } from "lucide-react";

const ProductRequestAdd = () => {
  const alertRef = useRef(null);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [errors, setErrors] = useState({});
  const [decodedToken, setDecodedToken] = useState();
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState(null);
  const [warehouseAddress, setWarehouseAddress] = useState("");
  const token = localStorage.getItem("coyote-token");
  const [jobs, setJobs] = useState([]);
  const [searchSelectedProducts, setSearchSelectedProducts] = useState("");
  const [optionsJob, setOptionsJob] = useState([]);
  const permissions = useSelector(SettingSelector?.set_permissions);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const [inactiveProductErrors, setInactiveProductErrors] = useState([]);

  const [jobIdProductRequest, setJobIdProductRequest] = useState(null);
  const [selectedSystemForFilter, setSelectedSystemForFilter] = useState(null);
  const [selectedPhaseForFilter, setSelectedPhaseForFilter] = useState(null);
  const [jobSystemsPhasesMap, setJobSystemsPhasesMap] = useState({});
  const [loadingSystemsPhases, setLoadingSystemsPhases] = useState(false);
  const [activePanel, setActivePanel] = useState("none");
  const isRightPanelOpen = activePanel === "addProducts";

  const [bulkJobId, setBulkJobId] = useState(null);
  const [bulkSystemId, setBulkSystemId] = useState(null);
  const [bulkPhaseId, setBulkPhaseId] = useState(null);
  const [bulkSystemOptions, setBulkSystemOptions] = useState([]);
  const [bulkPhaseOptions, setBulkPhaseOptions] = useState([]);

  const [spSearchText, setSpSearchText] = useState("");
  const [spProducts, setSpProducts] = useState([]);
  const [spTotal, setSpTotal] = useState(0);
  const [spNextOffset, setSpNextOffset] = useState(null);
  const [spOffset, setSpOffset] = useState(0);
  const [spLoadingInitial, setSpLoadingInitial] = useState(false);
  const [spLoadingMore, setSpLoadingMore] = useState(false);
  const [spSortConfig, setSpSortConfig] = useState({
    key: "productName",
    direction: "asc",
  });
  const [spSelectedJobId, setSpSelectedJobId] = useState(null);
  const [spSelectedSystemId, setSpSelectedSystemId] = useState(null);
  const [spSelectedPhaseId, setSpSelectedPhaseId] = useState(null);
  const [spSelectedVendorId, setSpSelectedVendorId] = useState("all");
  const [spSystemOptions, setSpSystemOptions] = useState([]);
  const [spPhaseOptions, setSpPhaseOptions] = useState([]);
  const [spLoadingSystems, setSpLoadingSystems] = useState(false);
  const [spSelectedProducts, setSpSelectedProducts] = useState([]);
  const [spValidationErrors, setSpValidationErrors] = useState({});
  const [spOptionsJob, setSpOptionsJob] = useState([]);
  const [spViewItem, setSpViewItem] = useState(null);
  const [spViewModal, setSpViewModal] = useState(false);
  const spRequestIdRef = useRef(0);
  const SP_LIMIT = 20;
  const [vendors, setVendors] = useState([]);


  const optionsVendor = useMemo(() => {
    return [
      { value: "all", label: "Select Vendor" },
      ...vendors.map((v) => ({
        value: v.id,
        label: v.name === "N/A" || !v.name ? "No vendor" : v.name,
      })),
    ];
  }, [vendors]);

  const [leftWidth, setLeftWidth] = useState(55);
  const [isResizing, setIsResizing] = useState(false);
  const containerRef = useRef(null);

  const startResizing = useCallback((e) => {
    setIsResizing(true);
    e.preventDefault();
  }, []);
  const stopResizing = useCallback(() => setIsResizing(false), []);
  const resize = useCallback(
    (e) => {
      if (isResizing && containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const newWidth = ((e.clientX - rect.left) / rect.width) * 100;
        if (newWidth >= 32 && newWidth <= 75) setLeftWidth(newWidth);
      }
    },
    [isResizing],
  );

  useEffect(() => {
    if (isResizing) {
      window.addEventListener("mousemove", resize);
      window.addEventListener("mouseup", stopResizing);
    } else {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    }
    return () => {
      window.removeEventListener("mousemove", resize);
      window.removeEventListener("mouseup", stopResizing);
    };
  }, [isResizing, resize, stopResizing]);

  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 769);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);

  const [hoveredTableProduct, setHoveredTableProduct] = useState(null);
  const [draggingRowProduct, setDraggingRowProduct] = useState(null);
  const [showOrderConfirmationModal, setShowOrderConfirmationModal] =
    useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [orderModalData, setOrderModalData] = useState({
    poNumber: "",
    vendorId: null,
    warehouseId: null,
    shipToAddress: "",
    items: [],
  });
  const [preOrderData, setPreOrderData] = useState(null);
  const [showItemsInModal, setShowItemsInModal] = useState(false);
  const [showPONumber, setShowPONumber] = useState(false);
  const showPONumberRef = useRef(false);
  const vendorSelectRef = useRef(null);

  const productHasPermission =
    permissions?.product_request?.add_custom_product === true;
  const productHasCreatePermission =
    permissions?.product_request?.create === true;
  const orderHasCreatePermission = permissions?.purchase_order?.create === true;
  const warehouseHasCreatePermission = permissions?.warehouse?.create === true;

  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const [sortConfigProductRequest, setSortConfigProductRequest] = useState({
    key: "productName",
    direction: "asc",
  });
  const [formDataProduct, setFormDataProduct] = useState({
    name: "",
    sku: "",
    categoryId: "",
    manufacturerId: null,
    model: "",
    inventoryType: "standard",
    upcNumber: "",
    msrp: "",
    cost: "",
    labourPerHourPerunit: "",
    rmu: "",
    backbox: "",
    technicalSpecs: [{ key: "", value: "" }],
    description: "",
    unitOfMeasure: "",
    weight: "",
    vendorId: "",
    dimensions: [{ key: "", value: "" }],
    phases: [null],
    productPictures: [],
  });

  const getLocalDate = () => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
  };

  const [formData, setFormData] = useState({
    date: getLocalDate(),
    shipTo: "",
    warehouseId: null,
    items: [],
    poNumber: "",
    vendorId: null,
  });
  const allowNavigationRef = useRef(false);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (allowNavigationRef.current) return false;
    return (
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname
    );
  });

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      if (hasUnsavedChanges && !allowNavigationRef.current) {
        setShowDiscardModal(true);
        setPendingNavigation(() => blocker.proceed);
      } else {
        blocker.reset();
        setShowDiscardModal(false);
        setPendingNavigation(null);
      }
    }
  }, [blocker.state, hasUnsavedChanges, blocker]);

  useEffect(() => {
    return () => {
      if (blocker.state === "blocked") blocker.reset();
      allowNavigationRef.current = false;
    };
  }, [blocker]);

  const handleDiscardChanges = useCallback(() => {
    if (blocker.state === "blocked") {
      setHasUnsavedChanges(false);
      setShowDiscardModal(false);
      if (pendingNavigation) {
        pendingNavigation();
        setPendingNavigation(null);
      } else if (blocker.proceed) blocker.proceed();
    }
  }, [blocker.state, pendingNavigation, blocker]);

  const handleCancelDiscard = useCallback(() => {
    if (blocker.state === "blocked") blocker.reset();
    setShowDiscardModal(false);
    setPendingNavigation(null);
  }, [blocker.state, blocker]);

  const fetchJobSystemsPhases = async (jobId) => {
    if (!jobId) return null;
    if (jobSystemsPhasesMap[jobId]) return jobSystemsPhasesMap[jobId];
    try {
      setLoadingSystemsPhases(true);
      const res = await axios.get(
        `${url.backendURL}product-request/${jobId}/job/systems-with-phases`,
        { headers: { Authorization: `${token}` } },
      );
      const data = res.data.response.data;
      setJobSystemsPhasesMap((prev) => ({ ...prev, [jobId]: data }));
      return data;
    } catch (err) {
      return null;
    } finally {
      setLoadingSystemsPhases(false);
    }
  };

  const getVendors = async () => {
    try {
      const res = await axios.get(`${url.backendURL}vendor/all`, {
        headers: { Authorization: `${token}` },
      });
      setVendors(res.data.response.data);
    } catch (err) {
      handleError(err, "product-request-add");
    }
  };

  const getWarehouses = async () => {
    try {
      const res = await axios.get(`${url.backendURL}user/warehouse-list`, {
        headers: { Authorization: `${token}` },
      });
      setWarehouses(res.data.response.data);
      if (decodedToken?.warehouse_id) {
        setWarehouseId(decodedToken?.warehouse_id);
        setWarehouseAddress(
          res.data.response.data.find(
            (w) => w.id === decodedToken?.warehouse_id,
          )?.address,
        );
        setFormData((prev) => ({
          ...prev,
          warehouseId: decodedToken?.warehouse_id,
        }));
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        setDecodedToken(jwtDecode(token)?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getJobs = async () => {
    try {
      const res = await axios.get(`${url.backendURL}job/all`, {
        headers: { Authorization: `${token}` },
      });
      setJobs(res.data.response.data);
    } catch (err) {
      handleError(err, "product-request-add");
    }
  };

  useEffect(() => {
    if (token && decodedToken) {
      const fetchData = async () => {
        await Promise.all([getWarehouses(), getVendors(), getJobs()]);
        setLoader(false);
      };
      fetchData();
    }
  }, [token, decodedToken]);

  const fetchProductSuggestions = async (
    inputValue,
    selectedProductIds = [],
    keyCol,
    directionCol,
    limit,
    offset,
  ) => {
    try {
      const productIdsString = (selectedProductIds || []).join(",");
      const res = await axios.get(`${url.backendURL}order/products`, {
        headers: { Authorization: `${token}` },
        params: {
          product: inputValue,
          searchKey: keyCol,
          searchDirection: directionCol,
          limit,
          offset,
          selectedProductIds: productIdsString,
          vendorId: spSelectedVendorId === "all" ? null : spSelectedVendorId,
        },
      });
      const products = res.data.response.data;
      const pagination = res.data.response.pagination;

      return {
        products: products.map((p) => ({
          productId: p.product_id,
          productName: p.product_name,
          rate: p.product_cost,
          quantity: 1,
          amount: 1 * p.product_cost,
          model: p.product_model,
          manufacturerId: p.manufacturer_id,
          manufacturerName: p.manufacturer_name,
          sku: p.sku,
          description: p.product_description,
          searchable_text: p.searchable_text,
          jobId: null,
          systemId: null,
          phaseId: null,
        })),
        total: pagination.total,
        offset: pagination.offset,
        nextOffset: pagination.nextOffset,
      };
    } catch (error) {
      if (
        error.response?.data?.error === "jwt expired" ||
        error.response?.data?.error === "Unauthorized. User not found"
      ) {
        localStorage.removeItem("coyote-token");
        navigate(
          `/${decodedToken?.roles?.some((r) => r.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
          { state: { status: "expired" } },
        );
      }
      return { products: [], total: 0, offset: 0, nextOffset: null };
    }
  };

  const spCreateKey = (productId, systemId, phaseId) =>
    `${productId}-${systemId || "null"}-${phaseId || "null"}`;

  const spIsInSelection = (productId, systemId, phaseId) => {
    const k = spCreateKey(productId, systemId, phaseId);
    return spSelectedProducts.some(
      (p) => spCreateKey(p.productId, p.systemId, p.phaseId) === k,
    );
  };

  const spLoadInitial = async (
    search = "",
    sortKey = "productName",
    sortDir = "asc",
    excludeIds = [],
  ) => {
    setSpLoadingInitial(true);
    spRequestIdRef.current += 1;
    const rid = spRequestIdRef.current;
    try {
      const data = await fetchProductSuggestions(
        search,
        excludeIds,
        sortKey,
        sortDir,
        SP_LIMIT,
        0,
      );
      if (spRequestIdRef.current !== rid) return;
      const prods = (data?.products || []).map((p) => ({
        ...p,
        jobId: spSelectedJobId,
        systemId: spSelectedSystemId,
        phaseId: spSelectedPhaseId,
        quantity: p.quantity || 1,
        rate: p.rate || 0,
        amount: (p.rate || 0) * (p.quantity || 1),
      }));
      setSpProducts(prods);
      setSpTotal(data?.total || 0);
      setSpNextOffset(data?.nextOffset || null);
      setSpOffset(0);
    } catch (err) {
      console.error("SP load error:", err);
    } finally {
      if (spRequestIdRef.current === rid) setSpLoadingInitial(false);
    }
  };

  const spLoadMore = async (excludeIds = []) => {
    if (!spNextOffset) return;
    setSpLoadingMore(true);
    try {
      const data = await fetchProductSuggestions(
        spSearchText,
        excludeIds,
        spSortConfig.key,
        spSortConfig.direction,
        SP_LIMIT,
        spNextOffset,
      );
      if (data?.products?.length > 0) {
        const prods = data.products.map((p) => ({
          ...p,
          jobId: spSelectedJobId,
          systemId: spSelectedSystemId,
          phaseId: spSelectedPhaseId,
          quantity: p.quantity || 1,
          rate: p.rate || 0,
          amount: (p.rate || 0) * (p.quantity || 1),
        }));
        setSpProducts((prev) => [...prev, ...prods]);
        setSpTotal(data.total || spTotal);
        setSpNextOffset(data.nextOffset || null);
        setSpOffset(data.offset || spOffset);
      }
    } catch (err) {
      console.error("SP load more error:", err);
    } finally {
      setSpLoadingMore(false);
    }
  };

  const spSelectRow = (product, onlySelect = false) => {
    setSpSelectedProducts((prev) => {
      const k = spCreateKey(
        product.productId,
        product.systemId,
        product.phaseId,
      );
      const isSel = prev.some(
        (p) => spCreateKey(p.productId, p.systemId, p.phaseId) === k,
      );
      if (isSel) {
        if (onlySelect) return prev;
        return prev.filter(
          (p) => spCreateKey(p.productId, p.systemId, p.phaseId) !== k,
        );
      }
      return [
        ...prev,
        {
          ...product,
          quantity: product.quantity || 1,
          rate: product.rate || 0,
          amount: (product.rate || 0) * (product.quantity || 1),
        },
      ];
    });
  };

  const spUpdateField = (productId, systemId, phaseId, key, value) => {
    const update = (item) => {
      if (
        item.productId !== productId ||
        item.systemId !== systemId ||
        item.phaseId !== phaseId
      )
        return item;
      return {
        ...item,
        [key]: value,
        amount:
          key === "rate"
            ? (parseFloat(value) || 0) * (parseFloat(item.quantity) || 1)
            : key === "quantity"
              ? (parseFloat(item.rate) || 0) * (parseFloat(value) || 0)
              : item.amount,
      };
    };
    setSpSelectedProducts((prev) => prev.map(update));
    setSpProducts((prev) => prev.map(update));
  };

  const spValidate = () => {
    const errs = {};
    let hasErrors = false;
    spSelectedProducts.forEach((item) => {
      const k = spCreateKey(item.productId, item.systemId, item.phaseId);
      errs[k] = {};
      if (!item.quantity || item.quantity <= 0) {
        errs[k].quantity = "Quantity is required";
        hasErrors = true;
      }
      if (
        item.rate === "" ||
        item.rate === null ||
        item.rate === undefined ||
        parseFloat(item.rate) <= 0
      ) {
        errs[k].rate = "Rate must be greater than 0";
        hasErrors = true;
      }
    });
    setSpValidationErrors(errs);
    return !hasErrors;
  };

  const resetSidePanel = () => {
    setSpProducts([]);
    setSpSearchText("");
    setSpSelectedProducts([]);
    setSpValidationErrors({});
    setSpSelectedJobId(null);
    setSpSelectedSystemId(null);
    setSpSelectedPhaseId(null);
    setSpSystemOptions([]);
    setSpPhaseOptions([]);
    setSpSortConfig({ key: "productName", direction: "asc" });
    setSpNextOffset(null);
    setSpOffset(0);
    setSpTotal(0);
  };


  useEffect(() => {
    if (isRightPanelOpen && spOptionsJob.length === 0 && token) {
      (async () => {
        try {
          const res = await axios.get(`${url.backendURL}job/all`, {
            headers: { Authorization: token },
          });
          const jobsList = res.data.response.data || [];
          setSpOptionsJob(
            jobsList.map((j) => ({
              value: j.id,
              label: j.name,
              phaseName: j.phase_name,
              systemName: j.system_name,
              siteName: j.site_name || "",
            })),
          );
        } catch (e) {
          console.error("SP fetch jobs error:", e);
        }
      })();
    }
  }, [isRightPanelOpen]);

  const spHandleAdd = (setFieldValue, currentItems, itemsOverride = null) => {
    const listToAdd = itemsOverride || spSelectedProducts;
    if (listToAdd.length === 0) return;
    const newItems = listToAdd.map((p) => {
      const jid = p.jobId || bulkJobId || null;
      const jobOpt = optionsJob.find(o => o.value === jid);
      return {
        productId: p.productId,
        productName: p.productName,
        rate: p.rate || 0,
        sku: p.sku || "",
        quantity: p.quantity || 1,
        amount: (p.rate || 0) * (p.quantity || 1),
        model: p.model || "",
        manufacturerId: p.manufacturerId || null,
        manufacturerName: p.manufacturerName || "",
        description: p.description || "",
        searchable_text: p.searchable_text || "",
        jobId: jid,
        systemId: p.systemId || (jid === bulkJobId ? bulkSystemId : null) || null,
        phaseId: p.phaseId || (jid === bulkJobId ? bulkPhaseId : null) || null,
      };
    });
    setSelectedAddedProducts((prev) => [...newItems, ...prev]);
    setFieldValue("items", [...newItems, ...(currentItems || [])]);
    setHasUnsavedChanges(true);
    setSpSelectedProducts([]);
    setActivePanel("none");
  };


  const handleCreateOrderFromPR = async (prData = null, orderData = null) => {
    try {
      setShowOrderConfirmationModal(false);
      const prFormData = prData || preOrderData;
      const orderFormData = orderData || orderModalData;
      if (!prFormData) throw new Error("Product request data is missing.");
      if (!orderFormData?.items?.length)
        throw new Error("No items found. Please add at least one item.");

      const hasSelectedItems = orderFormData.items.some(
        (item) => item.createOrder !== false,
      );
      const selectedOrderItems = orderFormData.items.filter(
        (item) => item.createOrder !== false,
      );

      const sanitizedItems = orderFormData.items.map((item) => {
        if (!item.productId)
          throw new Error("Item is missing. Please select a product");
        if (!item.quantity || item.quantity <= 0)
          throw new Error(
            "Item quantity is required and must be greater than 0",
          );
        if (!item.rate || item.rate <= 0)
          throw new Error("Item rate must be greater than 0");
        return {
          productId: item.productId,
          jobId: item.jobId || null,
          systemId: item.systemId || null,
          phaseId: item.phaseId || null,
          rate: parseFloat(item.rate),
          amount: parseFloat(item.amount || item.rate * item.quantity),
          quantity: parseInt(item.quantity),
        };
      });

      const sanitizedOrderItems = selectedOrderItems.map((item) => {
        if (!item.productId) throw new Error("Order item is missing");
        return {
          productId: item.productId,
          jobId: item.jobId || null,
          systemId: item.systemId || null,
          phaseId: item.phaseId || null,
          rate: parseFloat(item.rate),
          amount: parseFloat(item.amount || item.rate * item.quantity),
          quantity: parseInt(item.quantity),
        };
      });

      if (
        hasSelectedItems &&
        (!orderFormData.poNumber || orderFormData.poNumber.trim() === "")
      )
        throw new Error("PO Number is required when creating an order");
      if (hasSelectedItems && !orderFormData.vendorId)
        throw new Error("Vendor is required");

      const prWarehouseId = prFormData.warehouseId || warehouseId;
      const prShipTo = prFormData.shipTo || "";
      const prWarehouse = warehouseOptions.find(
        (w) => w.value === prWarehouseId,
      );
      const defaultShipTo = prShipTo || prWarehouse?.shipTo || "";

      const combinedData = {
        date: getLocalDate(),
        warehouseId: prWarehouseId,
        shipTo: prShipTo,
        items: sanitizedItems,
        poNumber: orderFormData.poNumber || "",
        vendorId: orderFormData.vendorId || null,
        orderWarehouseId: prWarehouseId,
        orderShipTo: defaultShipTo,
        orderItems: sanitizedOrderItems,
        createOrder: sanitizedOrderItems.length > 0,
      };

      const response = await axios.post(
        `${url.backendURL}product-request/create-with-order`,
        combinedData,
        { headers: { Authorization: `${token}` } },
      );

      if (response.data.success) {
        const hasOrder = response.data.response.data.orderId;
        setHasUnsavedChanges(false);
        setPreOrderData(null);
        setShowPONumber(false);
        setShowDiscardModal(false);
        setPendingNavigation(null);
        allowNavigationRef.current = true;
        if (blocker.state === "blocked") blocker.reset();
        if (hasOrder) {
          navigate("/dashboard/app/purchase-order-list", {
            state: { highlightedOrderId: response.data.response.data.orderId },
          });
        } else {
          navigate("/dashboard/app/product-request-list", {
            state: {
              highlightedPRId: response.data.response.data.productRequestId,
            },
          });
        }
        setTimeout(() => {
          allowNavigationRef.current = false;
        }, 100);
      }
    } catch (err) {
      setShowOrderConfirmationModal(false);
      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      if (err.response?.data?.response?.data)
        setInactiveProductErrors(
          err.response.data.response.data.map((e) => e.productId),
        );
      const errorMessage =
        err.message ||
        err.response?.data?.message ||
        err.response?.data?.error ||
        "An error occurred while creating the order";
      setAlert({
        message: errorMessage,
        type: "danger",
        show: true,
        alertFor: "product-request-add",
      });
      handleError(err, "product-request-add");
      setPreOrderData(null);
    }
  };

  const handleSubmit = async (
    values,
    { setSubmitting, resetForm, setTouched, setErrors },
  ) => {
    setSubmitting(true);
    try {
      const sanitizedValues = {
        ...values,
        warehouseId: warehouseId,
        items: values.items.map((item) => {
          const {
            productName,
            manufacturerName,
            description,
            model,
            manufacturerId,
            sku,
            siteName,
            searchable_text,
            phases,
            phaseNames,
            ...sanitizedItem
          } = item;
          return {
            ...sanitizedItem,
            systemId: item.systemId || null,
            phaseId: item.phaseId || null,
          };
        }),
      };
      if (selectedAction !== "order" || !showPONumber) {
        delete sanitizedValues.poNumber;
        delete sanitizedValues.vendorId;
      }
      
      if (selectedAction === "order" && showPONumber) {
        setPreOrderData(sanitizedValues);
        const prWarehouse = warehouseOptions.find(
          (w) => w.value === sanitizedValues.warehouseId,
        );
        const defaultShipTo = values.shipTo || prWarehouse?.shipTo || "";
        const orderDataForAPI = {
          poNumber: values.poNumber || "",
          vendorId: values.vendorId || null,
          warehouseId: sanitizedValues.warehouseId || null,
          shipToAddress: defaultShipTo,
          items: sanitizedValues.items.map((item) => ({
            ...item,
            createOrder: true,
          })),
        };
        setOrderModalData(orderDataForAPI);
        try {
          await handleCreateOrderFromPR(sanitizedValues, orderDataForAPI);
        } catch (error) {
          console.error("Error creating order:", error);
        } finally {
          setSubmitting(false);
        }
        return;
      }
      const response = await axios.post(
        `${url.backendURL}product-request/`,
        sanitizedValues,
        { headers: { Authorization: `${token}` } },
      );
      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      setInactiveProductErrors([]);
      setAlert({
        message: response.data.message,
        type: "success",
        show: true,
        alertFor: "product-request-add",
      });
      setErrors({});
      setHasUnsavedChanges(false);
      setTimeout(() => {
        setAlert({ show: false, alertFor: "", message: "", type: "" });
        navigate("/dashboard/app/product-request-list");
      }, 2000);
    } catch (err) {
      if (err.response?.data?.response?.data)
        setInactiveProductErrors(
          err.response.data.response.data.map((e) => e.productId),
        );
      handleError(err, "product-request-add");
    } finally {
      setSubmitting(false);
    }
  };

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current)
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((r) => r.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "expired" } },
      );
    } else {
      setErrors(response?.data?.error || {});
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        5000,
      );
    }
  };

  const validationSchema = () => {
    return Yup.object().shape({
      date: Yup.string().required("Date is required"),
      warehouseId: Yup.number()
        .integer("Warehouse must be a valid")
        .positive("Warehouse is invalid")
        .typeError("Warehouse is invalid")
        .required("Warehouse is required"),
      shipTo: Yup.string()
        .matches(
          /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9!@#$%^&*()_+=[\]{};':"\\|,.<>/?-\s]*$/,
          "Ship To must contain at least 2 character long",
        )
        .min(2)
        .max(255)
        .trim()
        .required("Ship To is required"),
      poNumber: showPONumberRef.current
        ? Yup.string()
            .matches(
              /^[A-Za-z0-9-]+$/,
              "PO # can only contain alphanumeric characters and hyphens",
            )
            .min(3, "PO # must be at least 3 characters")
            .required("PO # is required")
            .trim()
        : Yup.string().notRequired(),
      vendorId: showPONumberRef.current
        ? Yup.number().nullable().required("Vendor is required")
        : Yup.number().nullable().notRequired(),
      items: Yup.array()
        .of(
          Yup.object().shape({
            productId: Yup.number()
              .integer()
              .required("Product is required")
              .typeError("Product must be a valid"),
            manufacturerId: Yup.number()
              .integer()
              .required("Manufacturer is required")
              .typeError("Manufacturer must be a valid"),
            jobId: Yup.number()
              .integer()
              .nullable()
              .typeError("Job must be a valid"),
            systemId: Yup.number()
              .integer()
              .nullable()
              .typeError("System must be a valid"),
            phaseId: Yup.number()
              .integer()
              .nullable()
              .typeError("Phase must be a valid"),
            quantity: Yup.number()
              .required("Quantity is required")
              .integer("Quantity must be an integer")
              .typeError("Quantity must be a number")
              .positive("Quantity must be greater than 0"),
            rate: Yup.number()
              .required("Rate is required")
              .typeError("Rate must be a number")
              .moreThan(0, "Rate must be greater than 0")
              .max(9999999999999.99)
              .transform((v) => (v === "" ? null : v))
              .test(
                "is-decimal",
                "Rate must have a maximum of 2 decimal places",
                (v) => {
                  if (v === null) return true;
                  return /^[+-]?\d+(\.\d{1,2})?$/.test(v.toString());
                },
              )
              .test(
                "max-digits",
                "Rate cannot have more than 13 digits before decimal point",
                (v) => {
                  if (v === null) return true;
                  const [i] = v.toString().split(".");
                  return i.replace("-", "").length <= 13;
                },
              ),
            amount: Yup.number()
              .required("Amount is required")
              .typeError("Amount must be a number"),
          }),
        )
        .min(1, "At least one item is required")
        .required("Items are required"),
    });
  };

  useEffect(() => {
    setOptionsJob(
      jobs.length > 0
        ? jobs.map((job) => ({
            value: job.id,
            label: job.name,
            phaseName: job.phaseName,
            systemName: job.systemName,
            siteName: job.siteName,
          }))
        : [],
    );
  }, [jobs]);

  const [selectedAddedProducts, setSelectedAddedProducts] = useState([]);
  useEffect(() => {
    setHasUnsavedChanges(selectedAddedProducts.length > 0);
  }, [selectedAddedProducts]);

  const [itemView, setItemView] = useState();
  const [itemViewIndex, setItemViewIndex] = useState();
  const [valuesData, setValuesData] = useState();
  const [itemViewModel, setItemViewModel] = useState(false);
  const [productAddModel, setProductAddModel] = useState(false);

  const handleView = async (
    e,
    item,
    selectedProductIds = [],
    index,
    valuesData,
  ) => {
    e.preventDefault();
    setItemView(item);
    setItemViewModel(true);
    setProductAddModel(false);
    setItemViewIndex(index);
    setValuesData(valuesData);
  };
  const handleCloseView = async () => {
    setItemViewModel(false);
    setProductAddModel(false);
  };

  const validationSchemaItem = () =>
    Yup.object().shape({
      productId: Yup.number()
        .integer()
        .required("Product is required")
        .typeError("Product must be a valid"),
      manufacturerId: Yup.number()
        .integer()
        .required("Manufacturer is required")
        .typeError("Manufacturer must be a valid"),
      jobId: Yup.number().integer().nullable().typeError("Job must be a valid"),
      systemId: Yup.number()
        .integer()
        .nullable()
        .typeError("System must be a valid"),
      phaseId: Yup.number()
        .integer()
        .nullable()
        .typeError("Phase must be a valid"),
      quantity: Yup.number()
        .required("Quantity is required")
        .integer()
        .typeError("Quantity must be a number")
        .positive("Quantity must be greater than 0"),
      rate: Yup.number()
        .required("Rate is required")
        .typeError("Rate must be a number")
        .moreThan(0, "Rate must be greater than 0")
        .max(9999999999999.99)
        .transform((v) => (v === "" ? null : v))
        .test(
          "is-decimal",
          "Rate must have a maximum of 2 decimal places",
          (v) => {
            if (v === null) return true;
            return /^[+-]?\d+(\.\d{1,2})?$/.test(v.toString());
          },
        ),
      amount: Yup.number()
        .required("Amount is required")
        .typeError("Amount must be a number"),
    });

  const handleSubmitItem = async (values, { setSubmitting }) => {
    setSubmitting(true);
    const updatedItems = [...valuesData.items];
    updatedItems[itemViewIndex] = values;
    setFormData({ ...valuesData, items: updatedItems });
    setItemViewIndex(null);
    setItemViewModel(false);
    setSubmitting(false);
  };

  const handleSubmitProductData = async (
    data,
    setFieldValue,
    addedProducts,
  ) => {
    data = {
      productId: data.productId,
      productName: data.productName,
      rate: data.cost,
      sku: data.sku,
      quantity: 1,
      amount: 1 * data.cost,
      model: data.model,
      manufacturerId: data.manufacturerId,
      manufacturerName: data.manufacturerName,
      description: data.description,
      searchable_text: data.searchable_text,
      phases: data.phases,
      phaseNames: data.phase_names || data.phaseNames,
      jobId: null,
      systemId: null,
      phaseId: null,
    };
    setSelectedAddedProducts((prev) => [...prev, data]);
    setFieldValue("items", [...(addedProducts || []), data]);
  };

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  useEffect(() => {
    setWarehouseOptions(
      warehouses.length > 0
        ? warehouses.map((w) => ({
            value: w.id,
            label: w.name,
            shipTo: w.address,
          }))
        : [],
    );
  }, [warehouses]);
  useEffect(() => {
    setVendorOptions(
      vendors.length > 0
        ? vendors.map((v) => ({ value: v.id, label: v.name }))
        : [],
    );
  }, [vendors]);

  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleCollapse = () => setIsCollapsed((prev) => !prev);

  const handleSortProductRequest = async (columnKey, setFieldValue, values) => {
    let direction =
      sortConfigProductRequest.key === columnKey &&
      sortConfigProductRequest.direction === "asc"
        ? "desc"
        : "asc";
    setSortConfigProductRequest({ key: columnKey, direction });
    setFieldValue(
      "items",
      [...values.items].sort((a, b) => {
        let aV = a[columnKey]?.toString().toLowerCase();
        let bV = b[columnKey]?.toString().toLowerCase();
        if (aV < bV) return direction === "asc" ? -1 : 1;
        if (aV > bV) return direction === "asc" ? 1 : -1;
        return 0;
      }),
    );
  };

  const [clickSubmitProduct, setClickSubmitProduct] = useState(false);
  const [isLoadingMoreSelectedProduct] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchSelectedProducts, jobIdProductRequest]);

  const generateSearchableText = (item, job, actualSystemName, actualPhaseName) => {
    return [
      item.productName,
      item.manufacturerName,
      item.model,
      item.description,
      item.sku,
      job?.name,
      job?.siteName,
      actualPhaseName,
      actualSystemName,
      item.searchable_text,
      item.phaseNames || item.phase_names,
    ]
      .filter(Boolean)
      .join(" ")
      .toLowerCase()
      .replace(/[+-]/g, "");
  };

  const getFilteredItems = (items) => {
    if (
      !searchSelectedProducts.trim() &&
      !jobIdProductRequest &&
      !selectedSystemForFilter &&
      !selectedPhaseForFilter
    )
      return items || [];
    const normalize = (str) => str?.toLowerCase().replace(/[+-]/g, "") || "";
    const searchTerm = normalize(searchSelectedProducts);
    return (items || []).filter((item) => {
      const job = jobs.find((j) => j.id === item.jobId) || {};
      let actualSystemName = job.systemName;
      let actualPhaseName = job.phaseName;

      if (item.jobId && jobSystemsPhasesMap[item.jobId]) {
        const sys = jobSystemsPhasesMap[item.jobId].systems?.find(
          (s) => String(s.system_id) === String(item.systemId)
        );
        if (sys) {
          actualSystemName = sys.system_name;
          const phase = sys.phases?.find(
            (p) => String(p.phase_id) === String(item.phaseId)
          );
          if (phase) actualPhaseName = phase.phase_name;
        }
      }

      let searchMatch = true;
      if (searchSelectedProducts.trim()) {
        const combined = generateSearchableText(item, job, actualSystemName, actualPhaseName);
        searchMatch = searchTerm
          .trim()
          .split(/\s+/)
          .every((t) => combined.includes(t));
      }
      const jobMatch = jobIdProductRequest
        ? item.jobId?.toString() === jobIdProductRequest?.toString()
        : true;
      const systemMatch = selectedSystemForFilter
        ? item.systemId === selectedSystemForFilter.value
        : true;
      const phaseMatch = selectedPhaseForFilter
        ? item.phaseId === selectedPhaseForFilter.value
        : true;
      return searchMatch && jobMatch && systemMatch && phaseMatch;
    });
  };

  const getPaginatedItems = (items) => {
    const filtered = getFilteredItems(items);
    return filtered.slice(0, currentPage * itemsPerPage);
  };
  const hasMoreItems = (items) => {
    const filtered = getFilteredItems(items);
    return filtered.length > currentPage * itemsPerPage;
  };
  const loadMoreItems = () => setCurrentPage((prev) => prev + 1);

  return (
    <>
      <div>
        <Modal
          show={showDiscardModal}
          onHide={handleCancelDiscard}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
            <Modal.Title>Unsaved Changes</Modal.Title>
            <button
              type="button"
              className="btn-close-svg"
              style={{ position: "absolute", right: "1rem" }}
              onClick={handleCancelDiscard}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </Modal.Header>
          <Modal.Body className="text-center px-4 pt-2">
            <p
              className="text-muted mb-4 px-2"
              style={{ fontSize: "1rem", lineHeight: "1.5" }}
            >
              You have unsaved products added. Do you want to discard these
              changes?
            </p>
          </Modal.Body>
          <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
            <Button
              type="button"
              className="btn btn-white me-4"
              variant="btn btn-white"
              onClick={handleDiscardChanges}
              style={{
                borderRadius: "25px",
                fontWeight: "500",
                minWidth: "100px",
                borderColor: "#6c757d",
                color: "#6c757d",
              }}
            >
              Discard
            </Button>
            <Button
              className="px-4 py-2"
              style={{
                backgroundColor: "#3a57e8",
                borderColor: "#3a57e8",
                borderRadius: "25px",
                fontWeight: "500",
                minWidth: "100px",
              }}
              onClick={handleCancelDiscard}
            >
              Continue
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={itemViewModel}
          onHide={handleCloseView}
          backdrop="true"
          keyboard={true}
          size="lg"
        >
          <Modal.Header className="custom-modal-header">
            <Modal.Title>View Item</Modal.Title>
            <button
              type="button"
              className="btn-close-svg"
              onClick={handleCloseView}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </Modal.Header>
          <Formik
            initialValues={itemView}
            validationSchema={validationSchemaItem}
            onSubmit={handleSubmitItem}
            enableReinitialize
          >
            {({ values, handleChange, handleSubmit }) => (
              <Form
                className="form-horizontal ps-3 pe-3"
                onSubmit={handleSubmit}
              >
                <FocusError />
                <Modal.Body>
                  <Row>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Product Name</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.productName || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Make</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.manufacturerName || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Model</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={values?.model || ""}
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Site Name</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={
                            values?.jobId
                              ? optionsJob.find((o) => o.value === values.jobId)
                                  ?.siteName || "N/A"
                              : "N/A"
                          }
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm={12}>
                      <Form.Group className="form-group">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          readOnly
                          as="textarea"
                          value={values?.description || ""}
                          onChange={handleChange}
                          style={{
                            resize: "none",
                            fontSize: "0.8rem",
                            cursor: "not-allowed",
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control
                          type="text"
                          value={values?.quantity ?? ""}
                          readOnly
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Rate</Form.Label>
                        <Form.Control
                          type="text"
                          value={values?.rate || ""}
                          readOnly
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Amount</Form.Label>
                        <Form.Control
                          type="text"
                          value={values?.amount || 0}
                          readOnly
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Job</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={
                            values?.jobId
                              ? optionsJob.find((o) => o.value === values.jobId)
                                  ?.label || "No Job Assigned"
                              : "No Job Assigned"
                          }
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>System</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={
                            values?.jobId &&
                            values?.systemId &&
                            jobSystemsPhasesMap[values.jobId]
                              ? jobSystemsPhasesMap[values.jobId].systems.find(
                                  (s) => s.system_id === values.systemId,
                                )?.system_name || "N/A"
                              : "N/A"
                          }
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                    <Col sm="6">
                      <Form.Group className="form-group">
                        <Form.Label>Phase</Form.Label>
                        <Form.Control
                          readOnly
                          type="text"
                          value={
                            values?.jobId &&
                            values?.systemId &&
                            values?.phaseId &&
                            jobSystemsPhasesMap[values.jobId]
                              ? jobSystemsPhasesMap[values.jobId].systems
                                  .find((s) => s.system_id === values.systemId)
                                  ?.phases?.find(
                                    (p) => p.phase_id === values.phaseId,
                                  )?.phase_name || "N/A"
                              : "N/A"
                          }
                          style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Modal.Body>
              </Form>
            )}
          </Formik>
        </Modal>

        <Modal
          show={spViewModal}
          onHide={() => {
            setSpViewModal(false);
            setSpViewItem(null);
          }}
          backdrop="true"
          keyboard={true}
          size="lg"
          style={{ zIndex: 99999 }}
        >
          <Modal.Header className="custom-modal-header">
            <Modal.Title>View Product</Modal.Title>
            <button
              type="button"
              className="btn-close-svg"
              onClick={() => {
                setSpViewModal(false);
                setSpViewItem(null);
              }}
              aria-label="Close"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
              </svg>
            </button>
          </Modal.Header>
          <Modal.Body>
            {spViewItem && (
              <>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Product Name</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.productName || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Make</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.manufacturerName || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Model</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.model || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>SKU</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.sku || ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Form.Group className="form-group">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        readOnly
                        as="textarea"
                        value={spViewItem.description || ""}
                        style={{
                          resize: "none",
                          fontSize: "0.8rem",
                          cursor: "not-allowed",
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Quantity</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.quantity ?? ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Rate</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.rate ?? ""}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col sm="6">
                    <Form.Group className="form-group">
                      <Form.Label>Amount</Form.Label>
                      <Form.Control
                        readOnly
                        type="text"
                        value={spViewItem.amount ?? 0}
                        style={{ fontSize: "0.8rem", cursor: "not-allowed" }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}
          </Modal.Body>
        </Modal>

        <Formik
          enableReinitialize={true}
          initialValues={{ ...formData, shipTo: warehouseAddress, items: [] }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            handleChange,
            handleBlur,
            touched,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            resetForm,
            errors: errorsFormik,
            validateForm,
            setTouched,
            setErrors,
          }) => {
            useEffect(() => {
              if (isRightPanelOpen) {
                spLoadInitial(
                  spSearchText,
                  spSortConfig.key,
                  spSortConfig.direction,
                  values.items.map((p) => p.productId),
                );
              } else {
                resetSidePanel();
              }
            }, [
              isRightPanelOpen,
              spSearchText,
              spSortConfig.direction,
              values.items.length,
              spSelectedVendorId,
            ]);

            const spTableColumns = useMemo(
              () => [
                {
                  id: "spSelect",
                  size: 50,
                  Header: ({ table }) => {
                    const allSel =
                      spProducts.length > 0 &&
                      spProducts.every((p) =>
                        spSelectedProducts.some(
                          (sp) => sp.productId === p.productId,
                        ),
                      );
                    return (
                      <Checkbox
                        checked={allSel && !spLoadingInitial}
                        disabled={spLoadingInitial}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newOnes = spProducts.filter(
                              (p) =>
                                !spSelectedProducts.some(
                                  (sp) => sp.productId === p.productId,
                                ),
                            );
                            setSpSelectedProducts((prev) => [
                              ...prev,
                              ...newOnes.map((p) => ({
                                ...p,
                                quantity: p.quantity || 1,
                                rate: p.rate || 0,
                                amount: (p.rate || 0) * (p.quantity || 1),
                              })),
                            ]);
                          } else {
                            const keys = spProducts.map((p) => p.productId);
                            setSpSelectedProducts((prev) =>
                              prev.filter(
                                (p) => !keys.includes(p.productId),
                              ),
                            );
                          }
                        }}
                      />
                    );
                  },
                  Cell: ({ row }) => {
                    const p = row.original;
                    if (p.isLoadMoreRow) {
                      return (
                        <div
                          style={{
                            position: "sticky",
                            left: 0,
                            right: 0,
                            width: "fit-content",
                            margin: "0 auto",
                            display: "flex",
                            justifyContent: "center",
                            pointerEvents: "none",
                            zIndex: 10,
                            backgroundColor: "white",
                          }}
                        >
                          <div
                            style={{ pointerEvents: "auto", padding: "15px 0" }}
                          >
                            <button
                              type="button"
                              className="btn btn-outline-primary px-4 py-2"
                              onClick={() =>
                                spLoadMore(values.items.map((p) => p.productId))
                              }
                              disabled={spLoadingMore}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  "#3a57e8";
                                e.currentTarget.style.color = "#fff";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = "white";
                                e.currentTarget.style.color = "#3a57e8";
                              }}
                              style={{
                                borderRadius: "20px",
                                fontWeight: "400",
                                fontSize: "14px",
                                minWidth: "160px",
                              }}
                            >
                              {spLoadingMore ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" />
                                  Loading...
                                </>
                              ) : (
                                <>
                                  <i className="fas fa-plus-circle me-2" />
                                  Load More
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      );
                    }
                    const isSel = spSelectedProducts.some(
                      (sp) => sp.productId === p.productId,
                    );
                    return (
                      <Checkbox
                        checked={isSel}
                        disabled={spLoadingInitial}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => {
                          if (isSel) {
                            setSpSelectedProducts((prev) =>
                              prev.filter((sp) => sp.productId !== p.productId),
                            );
                          } else {
                            setSpSelectedProducts((prev) => [
                              ...prev,
                              {
                                ...p,
                                quantity: p.quantity || 1,
                                rate: p.rate || 0,
                                amount: (p.rate || 0) * (p.quantity || 1),
                              },
                            ]);
                          }
                        }}
                      />
                    );
                  },
                },
                {
                  accessorKey: "quantity",
                  header: "Qty",
                  size: 100,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {row.original.quantity || 1}
                      </span>
                    );
                  },
                },
                {
                  accessorKey: "manufacturerName",
                  header: "Make",
                  size: 140,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {row.original.manufacturerName || ""}
                      </span>
                    );
                  },
                },
                {
                  accessorKey: "model",
                  header: "Model",
                  size: 130,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {row.original.model || ""}
                      </span>
                    );
                  },
                },
                {
                  accessorKey: "description",
                  header: "Description",
                  size: 180,
                  Cell: ({ row }) => {
                    const p = row.original;
                    if (p.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {p.description || ""}
                      </span>
                    );
                  },
                },
                {
                  accessorKey: "sku",
                  header: "SKU",
                  size: 130,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {row.original.sku || ""}
                      </span>
                    );
                  },
                },
                {
                  accessorKey: "rate",
                  header: "Rate",
                  size: 130,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {row.original.rate || 0}
                      </span>
                    );
                  },
                },
                {
                  accessorKey: "amount",
                  header: "Amount",
                  size: 110,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <span style={{ fontSize: "0.85rem" }}>
                        {row.original.amount ?? 0}
                      </span>
                    );
                  },
                },

                {
                  id: "spAction",
                  header: "Action",
                  size: 70,
                  Cell: ({ row }) => {
                    if (row.original.isLoadMoreRow) return null;
                    return (
                      <Link
                        className="btn btn-sm btn-icon btn-success"
                        onClick={(e) => {
                          e.preventDefault();
                          setSpViewItem(row.original);
                          setSpViewModal(true);
                        }}
                        title="View"
                      >
                        <span className="btn-inner">
                          <IoEyeOutline
                            style={{ width: "20px", height: "20px" }}
                          />
                        </span>
                      </Link>
                    );
                  },
                },
              ],
              [
                spLoadingMore,
                values.items,
                spSelectedProducts,
                spProducts,
                spLoadingInitial,
              ],
            );

            const spTableData = useMemo(() => {
              if (
                !spLoadingInitial &&
                spNextOffset !== null &&
                spNextOffset < spTotal
              ) {
                return [
                  ...spProducts,
                  { id: "SP_LOAD_MORE_FAKE_ID", isLoadMoreRow: true },
                ];
              }
              return spProducts;
            }, [spProducts, spLoadingInitial, spNextOffset, spTotal]);

            const tableAddProducts = useMaterialReactTable({
              columns: spTableColumns,
              data: spTableData,
              enableColumnFilters: false,
              enableFullScreenToggle: false,
              enableFilterMatchHighlighting: false,
              enableRowDragging: true,
              enableRowSelection: false,
              enablePagination: false,
              enableBottomToolbar: false,
              muiTableBodyCellProps: ({ cell, row }) => {
                if (row.original.isLoadMoreRow) {
                  if (cell.column.id === "spSelect") {
                    return {
                      colSpan: 15,
                      sx: {
                        display: "block",
                        position: "sticky",
                        width: "100%",
                        left: "45%",
                        bottom: 0,
                        padding: "0",
                        borderBottom: "none",
                        zIndex: 10,
                        backgroundColor: "white",
                        height: "70px",
                        boxShadow: "0px -4px 10px rgba(0,0,0,0.05)",
                      },
                    };
                  }
                  return { sx: { display: "none" } };
                }
                return {};
              },
              muiTableBodyRowProps: ({ row }) => {
                const p = row.original;
                if (p.isLoadMoreRow) return { sx: { cursor: "default" } };
                return {
                  onClick: (e) => {
                    if (
                      ["INPUT", "BUTTON", "A", "TEXTAREA", "SELECT"].includes(
                        e.target.tagName,
                      ) ||
                   e.target.closest(".MuiCheckbox-root") ||
            e.target.closest(".MuiSelect-root") ||
            e.target.closest(".MuiTableDragHandle-root") ||
            e.target.closest("svg") ||
            e.target.closest(".react-select__control")
                    )
                      return;
                    const jid = bulkJobId || null;
                    const jobOpt = optionsJob.find((o) => o.value === jid);
                    const newItem = {
                      productId: p.productId,
                      productName: p.productName,
                      rate: p.rate || 0,
                      sku: p.sku || "",
                      quantity: p.quantity || 1,
                      amount: (p.rate || 0) * (p.quantity || 1),
                      model: p.model || "",
                      manufacturerId: p.manufacturerId || null,
                      manufacturerName: p.manufacturerName || "",
                      description: p.description || "",
                      searchable_text: p.searchable_text || "",
                      phases: p.phases || null,
                      phaseNames: p.phaseNames || p.phase_names || "",
                      jobId: jid,
                      systemId: bulkSystemId || null,
                      phaseId: bulkPhaseId || null,
                    };
                    setFieldValue("items", [newItem, ...(values.items || [])]);
                    setHasUnsavedChanges(true);
                  },
                  sx: {
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: "rgba(33,108,220,0.05)",
                    },
                  },
                };
              },
              enableGlobalFilter: true,
              manualFiltering: true,
              onGlobalFilterChange: setSpSearchText,
              enableTopToolbar: true,
              muiTopToolbarProps: { className: "compact-pagination-topbar" },
              onDraggingRowChange: setDraggingRowProduct,
              
              state: {
                isLoading: spLoadingInitial,
                globalFilter: spSearchText,
                draggingRow: draggingRowProduct,
              },
              muiRowDragHandleProps: ({ row }) => ({
                onDragEnd: () => {
                  if (hoveredTableProduct === "product-request-list") {
                    const p = row.original;
                    const itemsToMove = spSelectedProducts.some(
                      (item) => item.productId === p.productId,
                    )
                      ? spSelectedProducts
                      : [p];
                    spHandleAdd(setFieldValue, values.items, itemsToMove);
                  }
                  setHoveredTableProduct(null);
                  setDraggingRowProduct(null);
                },
              }),
              muiTableContainerProps: {
                sx: { minHeight: "60vh", maxHeight: "60vh" },
              },
              muiTablePaperProps: {
                onDragEnter: () => setHoveredTableProduct("general-product"),
                sx: { width: "100%", minWidth: "100%", overflow: "visible" },
              },
            });

            return (
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  setClickSubmitProduct(true);
                  handleSubmit();
                }}
              >
                <FocusError />
                <Row>
                  <Col xl="12" lg="12" ref={alertRef}>
                    <Card>
                      <div className="bd-example">
                        <Modal
                          show={showOrderConfirmationModal}
                          onHide={() => {
                            setShowOrderConfirmationModal(false);
                            setOrderModalData({
                              poNumber: "",
                              warehouseId: null,
                              shipToAddress: "",
                              items: [],
                            });
                            setPreOrderData(null);
                          }}
                          backdrop="static"
                          keyboard={true}
                          size="xl"
                          centered
                          style={{ zIndex: "9999" }}
                        >
                          <Modal.Header className="custom-modal-header">
                            <Modal.Title>Order Create</Modal.Title>
                            <button
                              type="button"
                              className="btn-close-svg"
                              onClick={() => {
                                setShowOrderConfirmationModal(false);
                                setOrderModalData({
                                  poNumber: "",
                                  warehouseId: null,
                                  shipToAddress: "",
                                  items: [],
                                });
                                setPreOrderData(null);
                              }}
                              aria-label="Close"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                              >
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                              </svg>
                            </button>
                          </Modal.Header>
                          <Modal.Body style={{ padding: "1rem" }}>
                            <Row>
                              <Col md={12}>
                                <div
                                  className="alert alert-success alert-dismissible fade show"
                                  role="alert"
                                >
                                  <strong>Note:</strong> The product request
                                  status will be automatically set to approved
                                  when you create this order.
                                  <button
                                    type="button"
                                    className="btn-close"
                                    onClick={(e) =>
                                      e.currentTarget.closest(".alert").remove()
                                    }
                                    aria-label="Close"
                                  ></button>
                                </div>
                              </Col>
                            </Row>
                            <Row md={12}>
                              <Col md={4}>
                                <Form.Group className="form-group">
                                  <Form.Label>
                                    PO Number{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter PO number"
                                    value={orderModalData.poNumber}
                                    onChange={(e) =>
                                      setOrderModalData({
                                        ...orderModalData,
                                        poNumber: e.target.value,
                                      })
                                    }
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="form-group">
                                  <Form.Label>
                                    Vendor{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Select
                                    options={vendorOptions}
                                    placeholder="Select Vendor..."
                                    value={vendorOptions.find(
                                      (o) =>
                                        o.value === orderModalData.vendorId,
                                    )}
                                    onChange={(opt) =>
                                      setOrderModalData({
                                        ...orderModalData,
                                        vendorId: opt?.value || null,
                                      })
                                    }
                                    styles={{
                                      control: (b) => ({ ...b, width: "100%" }),
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col md={4}>
                                <Form.Group className="form-group">
                                  <Form.Label>
                                    Warehouse{" "}
                                    <span className="text-danger">*</span>
                                  </Form.Label>
                                  <Select
                                    options={warehouseOptions}
                                    value={warehouseOptions.find(
                                      (o) =>
                                        o.value === orderModalData.warehouseId,
                                    )}
                                    onChange={(opt) => {
                                      const sel = warehouseOptions.find(
                                        (w) => w.value === opt?.value,
                                      );
                                      setOrderModalData({
                                        ...orderModalData,
                                        warehouseId: opt?.value || null,
                                        shipToAddress:
                                          sel?.shipTo ||
                                          orderModalData.shipToAddress ||
                                          "",
                                      });
                                    }}
                                    noOptionsMessage={() => (
                                      <div style={{ textAlign: "center" }}>
                                        <span style={{ color: "#666" }}>
                                          No warehouse found.
                                          {warehouseHasCreatePermission && (
                                            <span>
                                              {" "}
                                              <Link
                                                to="/dashboard/app/warehouse-add"
                                                style={{
                                                  color: "#007bff",
                                                  textDecoration: "none",
                                                }}
                                              >
                                                Add new
                                              </Link>
                                            </span>
                                          )}
                                        </span>
                                      </div>
                                    )}
                                    placeholder={
                                      warehouseOptions.length === 0 ? (
                                        <span>No warehouse found</span>
                                      ) : (
                                        "Select Warehouse..."
                                      )
                                    }
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    menuPlacement="auto"
                                    styles={{
                                      option: (b, s) => ({
                                        ...b,
                                        backgroundColor: s.isSelected
                                          ? "#007bff"
                                          : s.isFocused
                                            ? "#e6f7ff"
                                            : "#fff",
                                        color: "#333",
                                      }),
                                      menuPortal: (b) => ({
                                        ...b,
                                        zIndex: 9999,
                                      }),
                                      menu: (b) => ({ ...b, zIndex: 9999 }),
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            {orderModalData.warehouseId && (
                              <Row>
                                <Col md={12}>
                                  <Form.Group className="form-group">
                                    <Form.Label>
                                      Requesting Warehouse{" "}
                                      <span className="text-danger">*</span>
                                    </Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      rows={3}
                                      placeholder="Enter ship to"
                                      value={orderModalData.shipToAddress || ""}
                                      onChange={(e) =>
                                        setOrderModalData({
                                          ...orderModalData,
                                          shipToAddress: e.target.value,
                                        })
                                      }
                                      style={{
                                        backgroundColor: "#f8f9fa",
                                        borderRadius: "8px",
                                      }}
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            )}
                          </Modal.Body>
                          <Modal.Footer className="d-flex justify-content-end">
                            <Button
                              variant="primary"
                              disabled={(() => {
                                const has = orderModalData.items.some(
                                  (i) => i.createOrder !== false,
                                );
                                if (has)
                                  return (
                                    !orderModalData.poNumber ||
                                    !orderModalData.vendorId ||
                                    !orderModalData.warehouseId ||
                                    !orderModalData.shipToAddress
                                  );
                                return false;
                              })()}
                              onClick={handleCreateOrderFromPR}
                            >
                              {orderModalData.items.some(
                                (i) => i.createOrder !== false,
                              )
                                ? "Create Order"
                                : "Create PR"}
                            </Button>
                            <Button
                              variant="danger"
                              onClick={() => {
                                setShowOrderConfirmationModal(false);
                                setOrderModalData({
                                  poNumber: "",
                                  vendorId: null,
                                  warehouseId: null,
                                  shipToAddress: "",
                                  items: [],
                                });
                                setPreOrderData(null);
                              }}
                            >
                              Cancel
                            </Button>
                          </Modal.Footer>
                        </Modal>

                        <Modal
                          show={productAddModel}
                          onHide={handleCloseView}
                          backdrop="true"
                          keyboard={true}
                          className="w-90"
                          size="xl"
                        >
                          <Modal.Header className="custom-modal-header">
                            <Modal.Title>Product Add</Modal.Title>
                            <button
                              type="button"
                              className="btn-close-svg"
                              onClick={handleCloseView}
                              aria-label="Close"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                              >
                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                              </svg>
                            </button>
                          </Modal.Header>
                          <Modal.Body>
                            <ProductAddModel
                              handleCloseView={handleCloseView}
                              formData={formDataProduct}
                              setFormData={setFormDataProduct}
                              handleSubmitProductData={handleSubmitProductData}
                              setFieldValue={setFieldValue}
                              addedProducts={values.items}
                            />
                          </Modal.Body>
                        </Modal>
                      </div>

                      <Card.Header className="d-flex justify-content-between">
                        <div
                          className="breadcrumb header-title"
                          style={{ cursor: "pointer" }}
                        >
                          <h4
                            onClick={() =>
                              navigate("/dashboard/app/product-request-list")
                            }
                            className="text-primary card-title"
                            style={{ cursor: "pointer" }}
                          >
                            <span>Product Request</span>
                          </h4>
                          <h4 className="mx-2 card-title">{">"}</h4>
                          <h4 className="card-title">Add</h4>
                        </div>
                        <div>
                          <div
                            className="sidebar-toggle"
                            onClick={toggleCollapse}
                            style={{
                              position: "initial",
                              marginRight: "1.5rem",
                              cursor: "pointer",
                            }}
                          >
                            <i
                              className="icon"
                              style={{
                                transform: isCollapsed
                                  ? "rotate(270deg)"
                                  : "rotate(90deg)",
                              }}
                            >
                              <svg
                                width="20"
                                className="icon-20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M4.25 12.2744L19.25 12.2744"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                                <path
                                  d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></path>
                              </svg>
                            </i>
                          </div>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        <AlertNotificationSimple
                          type={alert.type}
                          message={alert.message}
                          show={alert.show}
                          onClose={() => setAlert({ ...alert, show: false })}
                        />
                        {!loader ? (
                          <>
                            {!isCollapsed && (
                              <Row className="mb-4 d-flex align-items-end new-product-request-info mr-0">
                                <Col md={7} className="mb-2 p-0">
                                  <Row className="m-0 align-items-end">
                                    <Col
                                      md={showPONumber ? 4 : 4}
                                      className="px-2"
                                    >
                                      <DatePickerField
                                        className="form-group mb-0"
                                        type="date"
                                        name="date"
                                        placeholder="Enter date"
                                        value={values.date}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        asterick={true}
                                        errorMessage={errors?.date}
                                        label="Date"
                                        dateFormat="MM/dd/yyyy"
                                      />
                                    </Col>
                                    {showPONumber && (
                                      <>
                                        <Col md={4} className="px-2">
                                          <Form.Group className="mb-0 w-100">
                                            <Form.Label
                                              className="w-100"
                                              style={{ marginBottom: "-1px" }}
                                            >
                                              PO Number
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              name="poNumber"
                                              className="mt-1"
                                              placeholder="Enter PO number"
                                              value={values.poNumber || ""}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                            />
                                          </Form.Group>
                                        </Col>
                                        <Col md={4} className="px-2">
                                          <Form.Group className="mb-0 w-100">
                                            <Form.Label
                                              className="w-100"
                                              style={{ marginBottom: "-1px" }}
                                            >
                                              Vendor
                                              <span className="text-danger">
                                                *
                                              </span>
                                            </Form.Label>
                                            <Select
                                              ref={vendorSelectRef}
                                              inputId="vendorId"
                                              name="vendorId"
                                              options={vendorOptions}
                                              placeholder="Select Vendor..."
                                              value={vendorOptions.find(
                                                (o) =>
                                                  o.value === values.vendorId,
                                              )}
                                              onChange={(opt) =>
                                                setFieldValue(
                                                  "vendorId",
                                                  opt?.value || null,
                                                )
                                              }
                                              className="mt-1 display-content-dropdown"
                                              menuPortalTarget={document.body}
                                              menuPosition="fixed"
                                              menuPlacement="auto"
                                              styles={{
                                                control: (b) => ({
                                                  ...b,
                                                  width: "100%",
                                                }),
                                                menuPortal: (b) => ({
                                                  ...b,
                                                  zIndex: 9999,
                                                }),
                                                menu: (b) => ({
                                                  ...b,
                                                  zIndex: 9999,
                                                }),
                                              }}
                                            />
                                          </Form.Group>
                                        </Col>
                                      </>
                                    )}
                                  </Row>
                                  {showPONumber && (
                                    <Row className="m-0 mt-1">
                                      <Col md={4} className="px-2"></Col>
                                      <Col md={4} className="px-2">
                                        <ErrorMessage
                                          name="poNumber"
                                          component="div"
                                          className="text-danger"
                                        />
                                        {errors.poNumber &&
                                          !touched.poNumber && (
                                            <div className="text-danger">
                                              {errors.poNumber}
                                            </div>
                                          )}
                                      </Col>
                                      <Col md={4} className="px-2">
                                        <ErrorMessage
                                          name="vendorId"
                                          component="div"
                                          className="text-danger"
                                        />
                                        {errors.vendorId && (
                                          <div className="text-danger">
                                            {errors.vendorId}
                                          </div>
                                        )}
                                      </Col>
                                    </Row>
                                  )}
                                </Col>
                                <Col
                                  md={5}
                                  className="d-flex justify-content-end m-0 p-0"
                                >
                                  <Form.Group className="col-12 col-lg-10 form-group flex flex-end mb-0">
                                    <Form.Label
                                      className="d-flex"
                                      style={{ whiteSpace: "nowrap" }}
                                    >
                                      Requesting Warehouse
                                      <span
                                        className="d-flex flex-row"
                                        style={{ width: "100%" }}
                                      >
                                        <span className="text-danger">*</span>
                                        <Select
                                          options={warehouseOptions}
                                          value={warehouseOptions.find(
                                            (o) => o.value === warehouseId,
                                          )}
                                          onChange={(opt) => {
                                            setWarehouseId(opt?.value || null);
                                            const shipTo =
                                              warehouseOptions.find(
                                                (w) => w.value === opt?.value,
                                              )?.shipTo;
                                            setFieldValue(
                                              "warehouseId",
                                              opt?.value || null,
                                            );
                                            setFieldValue(
                                              "shipTo",
                                              shipTo || values.shipTo,
                                            );
                                          }}
                                          placeholder={
                                            warehouseOptions.length === 0 ? (
                                              <span>No warehouse found</span>
                                            ) : (
                                              "Select Warehouse..."
                                            )
                                          }
                                          noOptionsMessage={() => (
                                            <div
                                              style={{ textAlign: "center" }}
                                            >
                                              <span style={{ color: "#666" }}>
                                                No warehouse found.
                                                {(warehouseHasCreatePermission ||
                                                  decodedToken?.roles.some(
                                                    (r) =>
                                                      r.role_type ===
                                                      roleTypes.SUPER_ADMIN,
                                                  )) && (
                                                  <span>
                                                    {" "}
                                                    <Link
                                                      to="/dashboard/app/warehouse-add"
                                                      style={{
                                                        color: "#007bff",
                                                        textDecoration: "none",
                                                      }}
                                                    >
                                                      Add new
                                                    </Link>
                                                  </span>
                                                )}
                                              </span>
                                            </div>
                                          )}
                                          className="display-content-dropdown"
                                          menuPortalTarget={document.body}
                                          menuPosition="fixed"
                                          menuPlacement="auto"
                                          styles={{
                                            option: (b, s) => ({
                                              ...b,
                                              backgroundColor: s.isSelected
                                                ? "#007bff"
                                                : s.isFocused
                                                  ? "#e6f7ff"
                                                  : "#fff",
                                              color: "#333",
                                            }),
                                            control: (b) => ({
                                              ...b,
                                              marginLeft: "1rem",
                                              color: "#5e667b",
                                              width: "100%",
                                            }),
                                            menuPortal: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                            menu: (b) => ({
                                              ...b,
                                              zIndex: 9999,
                                            }),
                                            placeholder: (b) => ({
                                              ...b,
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                            }),
                                          }}
                                        />
                                      </span>
                                    </Form.Label>
                                    <Form.Control
                                      id="shipTo"
                                      as="textarea"
                                      type="text"
                                      name="shipTo"
                                      placeholder="Enter Shipment Address"
                                      value={values?.shipTo}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      style={{
                                        resize: "none",
                                        height: "150px",
                                      }}
                                    />
                                    <ErrorMessage
                                      name="shipTo"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </Form.Group>
                                </Col>
                              </Row>
                            )}

                            <Row className="align-items-center mb-3">
                              <Col lg={12} md={12} sm={12}>
                                <div className="d-flex gap-4 flex-column flex-md-row justify-content-md-end justify-content-start text-nowrap">
                                  {productHasCreatePermission && (
                                    <Button
                                      variant="primary"
                                      className="text-nowrap d-flex align-items-center gap-2"
                                      onClick={() =>
                                        setActivePanel((prev) =>
                                          prev === "addProducts"
                                            ? "none"
                                            : "addProducts",
                                        )
                                      }
                                      style={{ borderRadius: "0.5rem" }}
                                    >
                                      {isRightPanelOpen ? (
                                        <span>Hide New Products</span>
                                      ) : (
                                        <>
                                          <Plus
                                            style={{
                                              width: "16px",
                                              height: "16px",
                                            }}
                                          />
                                          <span>Add New Products</span>
                                        </>
                                      )}
                                    </Button>
                                  )}
                                  {(productHasPermission ||
                                    decodedToken?.roles.some(
                                      (r) =>
                                        r.role_type === roleTypes.SUPER_ADMIN,
                                    )) && (
                                    <Button
                                      variant="success"
                                      className="text-nowrap"
                                      onClick={() => {
                                        setProductAddModel(true);
                                        setJobIdProductRequest(null);
                                        setSearchSelectedProducts("");
                                        setSelectedSystemForFilter(null);
                                        setSelectedPhaseForFilter(null);
                                      }}
                                    >
                                      Add Custom Product
                                    </Button>
                                  )}
                                </div>
                              </Col>
                            </Row>

                            <Row
                              className="d-flex"
                              ref={containerRef}
                              style={{
                                flexDirection: isMobile ? "column" : "row",
                                flexWrap: isMobile ? "wrap" : "nowrap",
                                position: "relative",
                              }}
                            >
                              <Col
                                md="auto"
                                sm={12}
                                className="m-0 p-0"
                                style={{
                                  width: isMobile
                                    ? "100%"
                                    : isRightPanelOpen
                                      ? `calc(${leftWidth}% - 5px)`
                                      : "100%",
                                  transition: isResizing
                                    ? "none"
                                    : "width 0.5s ease-in-out",
                                  flex: isMobile ? "1 1 auto" : "0 0 auto",
                                }}
                              >
                                <Card>
                                <Card.Header className="d-flex flex-column ps-0">
                                  <div className="header-title w-100 mb-3">
                                    <h5 className="card-title">Product Request Items</h5>
                                  </div>
                                  <Row className="mb-3 mt-2 w-100 align-items-end flex-nowrap" style={{ overflowX: "auto" }}>
                                    <Col style={{ minWidth: "140px", flex: 1 }}>
                                      <Select
                                        options={optionsJob}
                                        value={optionsJob.find(o => o.value === bulkJobId) || null}
                                        onChange={async (opt) => {
                                          const newJobId = opt?.value || null;
                                          setBulkJobId(newJobId);
                                          setBulkSystemId(null);
                                          setBulkPhaseId(null);
                                          setBulkSystemOptions([]);
                                          setBulkPhaseOptions([]);

                                          const applyToItems = (jid, sid, pid) => {
                                            setFieldValue("items", values.items.map(p => {
                                              const update = { ...p };
                                              let changed = false;
                                              if (jid && !p.jobId) {
                                                const jobOpt = optionsJob.find(o => o.value === jid);
                                                update.jobId = jid;
                                                update.siteName = jobOpt?.siteName || "";
                                                changed = true;
                                              }
                                              if (sid && !p.systemId && update.jobId === jid) {
                                                update.systemId = sid;
                                                changed = true;
                                              }
                                              if (pid && !p.phaseId && update.systemId === sid) {
                                                update.phaseId = pid;
                                                changed = true;
                                              }
                                              return changed ? update : p;
                                            }));
                                          };

                                          if (newJobId) {
                                            setLoadingSystemsPhases(true);
                                            try {
                                              let jd = jobSystemsPhasesMap[newJobId] || await fetchJobSystemsPhases(newJobId);
                                              if (jd?.systems) {
                                                const systems = jd.systems.map(s => ({ value: s.system_id, label: s.system_name, phases: s.phases }));
                                                setBulkSystemOptions(systems);
                                                let finalSid = jd.active_system_id || null;
                                                let finalPid = null;
                                                if (finalSid) {
                                                  setBulkSystemId(finalSid);
                                                  const activeSys = systems.find(s => s.value === finalSid);
                                                  if (activeSys?.phases && jd.active_phase_id) {
                                                    finalPid = jd.active_phase_id;
                                                    setBulkPhaseOptions(activeSys.phases.map(p => ({ value: p.phase_id, label: p.phase_name })));
                                                    setBulkPhaseId(finalPid);
                                                  }
                                                }
                                                applyToItems(newJobId, finalSid, finalPid);
                                              } else applyToItems(newJobId, null, null);
                                            } finally { setLoadingSystemsPhases(false); }
                                          } else applyToItems(null, null, null);
                                        }}
                                        isClearable
                                        placeholder="Select Job"
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        menuPlacement="auto"
                                        styles={{
                                          container: (b) => ({ ...b, width: "100%" }),
                                          option: (b, s) => ({
                                            ...b,
                                            backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                                            color: "#333",
                                            fontSize: "0.8rem",
                                          }),
                                          placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                          singleValue: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                          menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                          menu: (b) => ({ ...b, zIndex: 9999 }),
                                        }}
                                      />
                                    </Col>
                                    <Col style={{ minWidth: "140px", flex: 1 }}>
                                      <Select
                                        options={bulkSystemOptions}
                                        value={bulkSystemOptions.find(o => o.value === bulkSystemId) || null}
                                        onChange={(opt) => {
                                          const sid = opt?.value || null;
                                          setBulkSystemId(sid);
                                          setBulkPhaseId(null);
                                          if (!sid) setBulkPhaseOptions([]);
                                          else {
                                            const sys = bulkSystemOptions.find(s => s.value === sid);
                                            if (sys?.phases) setBulkPhaseOptions(sys.phases.map(p => ({ value: p.phase_id, label: p.phase_name })));
                                          }
                                          setFieldValue("items", values.items.map(p => (p.jobId === bulkJobId && !p.systemId) ? { ...p, systemId: sid, phaseId: null } : p));
                                        }}
                                        isClearable
                                        isDisabled={!bulkJobId}
                                        placeholder={!bulkJobId ? "Select job first" : "Select System"}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        menuPlacement="auto"
                                        styles={{
                                          container: (b) => ({ ...b, width: "100%" }),
                                          option: (b, s) => ({
                                            ...b,
                                            backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                                            color: "#333",
                                            fontSize: "0.8rem",
                                          }),
                                          placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                          singleValue: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                          menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                          menu: (b) => ({ ...b, zIndex: 9999 }),
                                        }}
                                      />
                                    </Col>
                                    <Col style={{ minWidth: "140px", flex: 1 }}>
                                      <Select
                                        options={bulkPhaseOptions}
                                        value={bulkPhaseOptions.find(o => o.value === bulkPhaseId) || null}
                                        onChange={(opt) => {
                                          const pid = opt?.value || null;
                                          setBulkPhaseId(pid);
                                          setFieldValue("items", values.items.map(p => (p.systemId === bulkSystemId && !p.phaseId) ? { ...p, phaseId: pid } : p));
                                        }}
                                        isClearable
                                        isDisabled={!bulkSystemId}
                                        placeholder={!bulkSystemId ? "Select system first" : "Select Phase"}
                                        menuPortalTarget={document.body}
                                        menuPosition="fixed"
                                        menuPlacement="auto"
                                        styles={{
                                          container: (b) => ({ ...b, width: "100%" }),
                                          option: (b, s) => ({
                                            ...b,
                                            backgroundColor: s.isSelected ? "#007bff" : s.isFocused ? "#e6f7ff" : "#fff",
                                            color: "#333",
                                            fontSize: "0.8rem",
                                          }),
                                          placeholder: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                          singleValue: (b) => ({ ...b, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }),
                                          menuPortal: (b) => ({ ...b, zIndex: 9999 }),
                                          menu: (b) => ({ ...b, zIndex: 9999 }),
                                        }}
                                      />
                                    </Col>
                                    <Col style={{ minWidth: "170px", flex: 1 }} className="ms-md-4">
                                      <Form.Group className="mb-0">
                                        <Form.Label className="w-100 mb-0" style={{ fontSize: "0.85rem", color: "#6c757d" }}>
                                          Search
                                          <span className="d-flex flex-col" style={{ width: "100%", display: "inline-flex" }}>
                                            <Form.Control
                                              type="text"
                                              name="name"
                                              className="mt-1 w-100"
                                              placeholder="Search product..."
                                              value={searchSelectedProducts}
                                              onChange={(e) => setSearchSelectedProducts(e.target.value)}
                                              style={{ paddingTop: "7px", paddingBottom: "7px" }}
                                            />
                                          </span>
                                        </Form.Label>
                                      </Form.Group>
                                    </Col>
                                  </Row>
                                </Card.Header>
                                <Card.Body className="ps-0 pe-0">
                                  <Box
                                    sx={{
                                      pb: "4px",
                                      width: "100%",
                          
                                    }}
                                  >
                                    {((typeof errorsFormik?.items ===
                                      "string" &&
                                      selectedAddedProducts.length === 0 &&
                                      clickSubmitProduct) ||
                                      (typeof errorsFormik?.items ===
                                        "string" &&
                                        values?.items?.length === 0 &&
                                        clickSubmitProduct)) && (
                                      <span className="text-danger">
                                        {errorsFormik.items}
                                      </span>
                                    )}
                                    <div
                                      className="table-responsive relative"
                                      onDragOver={(e) => {
                                        e.preventDefault();
                                        setHoveredTableProduct(
                                          "product-request-list",
                                        );
                                      }}
                                      onDragLeave={() =>
                                        setHoveredTableProduct(null)
                                      }
                                      style={{
                                        outline:
                                          hoveredTableProduct ===
                                          "product-request-list"
                                            ? "2px dashed #216CDC"
                                            : "none",
                                        borderRadius: "8px",
                                        transition: "all 0.2s",
                                      }}
                                    >
                                      <Table
                                        id="product-request-list-table"
                                        className="overflow-auto"
                                        role="grid"
                                        responsive
                                        style={{ width: "100%" }}
                                      >
                                        <thead>
                                          <tr
                                            style={{
                                              backgroundColor: "#e2e4e9",
                                            }}
                                          >
                                            <th style={{ minWidth: "100px" }}>
                                              Quantity
                                            </th>
                                            <th
                                              onClick={() =>
                                                handleSortProductRequest(
                                                  "manufacturerName",
                                                  setFieldValue,
                                                  values,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                              className="user-select-none"
                                            >
                                              <div className="d-flex flex-row align-items-end">
                                                Make{" "}
                                                <span className="d-flex flex-column ms-2">
                                                  <BsCaretUpFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "manufacturerName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "asc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                  <BsCaretDownFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "manufacturerName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "desc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              onClick={() =>
                                                handleSortProductRequest(
                                                  "model",
                                                  setFieldValue,
                                                  values,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                              className="user-select-none"
                                            >
                                              <div className="d-flex flex-row align-items-end">
                                                Model{" "}
                                                <span className="d-flex flex-column ms-2">
                                                  <BsCaretUpFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "model" &&
                                                      sortConfigProductRequest.direction ===
                                                        "asc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                  <BsCaretDownFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "model" &&
                                                      sortConfigProductRequest.direction ===
                                                        "desc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            </th>
                                            <th
                                              onClick={() =>
                                                handleSortProductRequest(
                                                  "productName",
                                                  setFieldValue,
                                                  values,
                                                )
                                              }
                                              style={{ cursor: "pointer" }}
                                            >
                                              <div className="d-flex flex-row align-items-end user-select-none">
                                                Description{" "}
                                                <span className="d-flex flex-column ms-2">
                                                  <BsCaretUpFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "productName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "asc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                  <BsCaretDownFill
                                                    color={
                                                      sortConfigProductRequest.key ===
                                                        "productName" &&
                                                      sortConfigProductRequest.direction ===
                                                        "desc"
                                                        ? "#3a57e8"
                                                        : "#ccc"
                                                    }
                                                  />
                                                </span>
                                              </div>
                                            </th>
                                       
                                            <th style={{ minWidth: "200px" }}>
                                              SKU
                                            </th>
                                            <th style={{ minWidth: "200px" }}>
                                              Rate
                                            </th>
                                            <th style={{ minWidth: "200px" }}>
                                              Amount
                                            </th>
                                            <th style={{ minWidth: "200px" }}>
                                              Job
                                            </th>
                                            <th style={{ minWidth: "200px" }}>
                                              System
                                            </th>
                                            <th style={{ minWidth: "200px" }}>
                                              Phase
                                            </th>
                                            <th style={{ minWidth: "200px" }}>
                                              Site Name
                                            </th>
                                            <th style={{ minWidth: "100px" }}>
                                              Action
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <FieldArray
                                            name="items"
                                            render={(arrayHelpers) => {
                                              if (
                                                values.items.length <=
                                                itemsPerPage
                                              )
                                                setCurrentPage(1);
                                              const paginatedItems =
                                                getPaginatedItems(values.items);
                                              const showLoadMore = hasMoreItems(
                                                values.items,
                                              );
                                              return (
                                                <>
                                                  {paginatedItems?.map(
                                                    (item, index) => {
                                                      const originalIndex =
                                                        values.items.findIndex(
                                                          (oi) =>
                                                            oi.productId ===
                                                            item.productId,
                                                        );
                                                      const formikErrors =
                                                        errorsFormik?.items?.[
                                                          originalIndex
                                                        ];
                                                      const touchedFields =
                                                        touched?.items?.[
                                                          originalIndex
                                                        ];
                                                      const generalErrors =
                                                        errors?.items?.[
                                                          originalIndex
                                                        ];
                                                      const shouldShowBorder =
                                                        (formikErrors &&
                                                          touchedFields) ||
                                                        generalErrors;
                                                      return (
                                                        <tr
                                                          key={item.productId}
                                                          className="bg-selected-product"
                                                          style={{
                                                            ...(shouldShowBorder ||
                                                            inactiveProductErrors.includes(
                                                              item.productId,
                                                            )
                                                              ? {
                                                                  border:
                                                                    "2px solid red",
                                                                }
                                                              : {}),
                                                          }}
                                                        >
                                                          <td>
                                                            <Form.Control
                                                              type="text"
                                                              name={`items.${originalIndex}.quantity`}
                                                              step="1"
                                                              min={0}
                                                              max={99999}
                                                              value={
                                                                item.quantity ||
                                                                ""
                                                              }
                                                              onChange={(e) => {
                                                                const v =
                                                                  e.target
                                                                    .value;
                                                                if (v === "") {
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.quantity`,
                                                                    "",
                                                                  );
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.amount`,
                                                                    "",
                                                                  );
                                                                  return;
                                                                }
                                                                if (
                                                                  !/^\d+$/.test(
                                                                    v,
                                                                  )
                                                                )
                                                                  return;
                                                                const n =
                                                                  parseInt(
                                                                    v,
                                                                    10,
                                                                  );
                                                                if (n > 99999)
                                                                  return;
                                                                if (
                                                                  !isNaN(n) &&
                                                                  n.toString() ===
                                                                    v &&
                                                                  n >= 0
                                                                ) {
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.quantity`,
                                                                    n,
                                                                  );
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.amount`,
                                                                    parseFloat(
                                                                      (
                                                                        n *
                                                                        (item.rate ??
                                                                          0)
                                                                      ).toFixed(
                                                                        2,
                                                                      ),
                                                                    ),
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                width: "100px",
                                                                fontSize:
                                                                  "0.8rem",
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.quantity`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              readOnly
                                                              type="text"
                                                              value={
                                                                item.manufacturerName ||
                                                                ""
                                                              }
                                                              style={{
                                                                width: "200px",
                                                                fontSize:
                                                                  "0.8rem",
                                                                cursor:
                                                                  "not-allowed",
                                                              }}
                                                            />
                                                            <Form.Control
                                                              type="hidden"
                                                              name={`items.${originalIndex}.manufacturerId`}
                                                              value={
                                                                item.manufacturerId ||
                                                                ""
                                                              }
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.manufacturerId`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              readOnly
                                                              type="text"
                                                              value={
                                                                item.model || ""
                                                              }
                                                              style={{
                                                                resize: "none",
                                                                width: "auto",
                                                                fontSize:
                                                                  "0.8rem",
                                                                cursor:
                                                                  "not-allowed",
                                                              }}
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              readOnly
                                                              type="text"
                                                              value={
                                                                item.description ||
                                                                ""
                                                              }
                                                              style={{
                                                                width: "200px",
                                                                fontSize:
                                                                  "0.8rem",
                                                                cursor:
                                                                  "not-allowed",
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.productId`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              readOnly
                                                              type="text"
                                                              value={
                                                                item.sku || ""
                                                              }
                                                              style={{
                                                                resize: "none",
                                                                width: "auto",
                                                                fontSize:
                                                                  "0.8rem",
                                                                cursor:
                                                                  "not-allowed",
                                                              }}
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              type="text"
                                                              step="0.01"
                                                              min={0}
                                                              name={`items.${originalIndex}.rate`}
                                                              value={
                                                                item.rate ?? ""
                                                              }
                                                              onChange={(e) => {
                                                                const iv =
                                                                  e.target
                                                                    .value;
                                                                if (iv === "") {
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.rate`,
                                                                    "",
                                                                  );
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.amount`,
                                                                    "0.00",
                                                                  );
                                                                  return;
                                                                }
                                                                if (
                                                                  /^\d*\.?\d{0,2}$/.test(
                                                                    iv,
                                                                  )
                                                                ) {
                                                                  const [ip] =
                                                                    iv.split(
                                                                      ".",
                                                                    );
                                                                  if (
                                                                    ip &&
                                                                    ip.length >
                                                                      13
                                                                  )
                                                                    return;
                                                                  const nv =
                                                                    parseFloat(
                                                                      iv,
                                                                    );
                                                                  if (
                                                                    nv >
                                                                    9999999999999.99
                                                                  )
                                                                    return;
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.rate`,
                                                                    iv,
                                                                  );
                                                                  setFieldValue(
                                                                    `items.${originalIndex}.amount`,
                                                                    parseFloat(
                                                                      iv &&
                                                                        item.quantity
                                                                        ? (
                                                                            (parseFloat(
                                                                              iv,
                                                                            ) ||
                                                                              0) *
                                                                            item.quantity
                                                                          ).toFixed(
                                                                            2,
                                                                          )
                                                                        : "0.00",
                                                                    ),
                                                                  );
                                                                }
                                                              }}
                                                              style={{
                                                                width: "200px",
                                                                fontSize:
                                                                  "0.8rem",
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.rate`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              type="text"
                                                              step="0.01"
                                                              min={0}
                                                              name={`items.${originalIndex}.amount`}
                                                              value={
                                                                item.amount || 0
                                                              }
                                                              readOnly
                                                              style={{
                                                                width: "200px",
                                                                fontSize:
                                                                  "0.8rem",
                                                                cursor:
                                                                  "not-allowed",
                                                              }}
                                                            />
                                                          </td>
                                                          <td>
                                                            <Select
                                                              name={`items.${originalIndex}.jobId`}
                                                              options={
                                                                optionsJob
                                                              }
                                                              value={
                                                                optionsJob.find(
                                                                  (o) =>
                                                                    o.value ===
                                                                    item.jobId,
                                                                ) || null
                                                              }
                                                              onChange={async (
                                                                opt,
                                                              ) => {
                                                                const nj =
                                                                  opt?.value ||
                                                                  null;
                                                                setFieldValue(
                                                                  `items.${originalIndex}.jobId`,
                                                                  nj,
                                                                );
                                                                setFieldValue(
                                                                  `items.${originalIndex}.systemId`,
                                                                  null,
                                                                );
                                                                setFieldValue(
                                                                  `items.${originalIndex}.phaseId`,
                                                                  null,
                                                                );
                                                                if (nj) {
                                                                  const jd =
                                                                    await fetchJobSystemsPhases(
                                                                      nj,
                                                                    );
                                                                  if (
                                                                    jd?.active_system_id &&
                                                                    jd?.active_phase_id
                                                                  ) {
                                                                    setTimeout(
                                                                      () => {
                                                                        setFieldValue(
                                                                          `items.${originalIndex}.systemId`,
                                                                          jd.active_system_id,
                                                                        );
                                                                        setFieldValue(
                                                                          `items.${originalIndex}.phaseId`,
                                                                          jd.active_phase_id,
                                                                        );
                                                                      },
                                                                      100,
                                                                    );
                                                                  }
                                                                }
                                                              }}
                                                              isClearable
                                                              placeholder="Select Job"
                                                              menuPortalTarget={
                                                                document.body
                                                              }
                                                              menuPosition="fixed"
                                                              menuPlacement="auto"
                                                              styles={{
                                                                container: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  width:
                                                                    "200px",
                                                                }),
                                                                option: (
                                                                  b,
                                                                  s,
                                                                ) => ({
                                                                  ...b,
                                                                  backgroundColor:
                                                                    s.isSelected
                                                                      ? "#007bff"
                                                                      : s.isFocused
                                                                        ? "#e6f7ff"
                                                                        : "#fff",
                                                                  color: "#333",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }),
                                                                menuPortal: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  zIndex: 9999,
                                                                }),
                                                                menu: (b) => ({
                                                                  ...b,
                                                                  zIndex: 9999,
                                                                }),
                                                                control: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  color:
                                                                    "#5e667b",
                                                                }),
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.jobId`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Select
                                                              name={`items.${originalIndex}.systemId`}
                                                              options={
                                                                item.jobId &&
                                                                jobSystemsPhasesMap[
                                                                  item.jobId
                                                                ]
                                                                  ? jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ].systems.map(
                                                                      (s) => ({
                                                                        value:
                                                                          s.system_id,
                                                                        label:
                                                                          s.system_name,
                                                                      }),
                                                                    )
                                                                  : []
                                                              }
                                                              value={
                                                                item.jobId &&
                                                                jobSystemsPhasesMap[
                                                                  item.jobId
                                                                ] &&
                                                                item.systemId
                                                                  ? jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ].systems
                                                                      .map(
                                                                        (
                                                                          s,
                                                                        ) => ({
                                                                          value:
                                                                            s.system_id,
                                                                          label:
                                                                            s.system_name,
                                                                        }),
                                                                      )
                                                                      .find(
                                                                        (o) =>
                                                                          o.value ===
                                                                          item.systemId,
                                                                      )
                                                                  : null
                                                              }
                                                              onChange={async (
                                                                opt,
                                                              ) => {
                                                                const ns =
                                                                  opt?.value ||
                                                                  null;
                                                                setFieldValue(
                                                                  `items.${originalIndex}.systemId`,
                                                                  ns,
                                                                );
                                                                setFieldValue(
                                                                  `items.${originalIndex}.phaseId`,
                                                                  null,
                                                                );
                                                                if (
                                                                  ns &&
                                                                  item.jobId
                                                                ) {
                                                                  if (
                                                                    !jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ]
                                                                  )
                                                                    await fetchJobSystemsPhases(
                                                                      item.jobId,
                                                                    );
                                                                  const jd =
                                                                    jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ];
                                                                  if (
                                                                    jd &&
                                                                    ns ===
                                                                      jd.active_system_id &&
                                                                    jd.active_phase_id
                                                                  ) {
                                                                    setTimeout(
                                                                      () =>
                                                                        setFieldValue(
                                                                          `items.${originalIndex}.phaseId`,
                                                                          jd.active_phase_id,
                                                                        ),
                                                                      100,
                                                                    );
                                                                  }
                                                                }
                                                              }}
                                                              isClearable
                                                              isDisabled={
                                                                !item.jobId
                                                              }
                                                              placeholder={
                                                                !item.jobId
                                                                  ? "First select a job"
                                                                  : "Select System"
                                                              }
                                                              menuPortalTarget={
                                                                document.body
                                                              }
                                                              menuPosition="fixed"
                                                              menuPlacement="auto"
                                                              styles={{
                                                                container: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  width:
                                                                    "200px",
                                                                }),
                                                                option: (
                                                                  b,
                                                                  s,
                                                                ) => ({
                                                                  ...b,
                                                                  backgroundColor:
                                                                    s.isSelected
                                                                      ? "#007bff"
                                                                      : s.isFocused
                                                                        ? "#e6f7ff"
                                                                        : "#fff",
                                                                  color: "#333",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }),
                                                                menuPortal: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  zIndex: 9999,
                                                                }),
                                                                menu: (b) => ({
                                                                  ...b,
                                                                  zIndex: 9999,
                                                                }),
                                                                control: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  color:
                                                                    "#5e667b",
                                                                }),
                                                                placeholder: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                }),
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.systemId`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Select
                                                              name={`items.${originalIndex}.phaseId`}
                                                              options={
                                                                item.jobId &&
                                                                item.systemId &&
                                                                jobSystemsPhasesMap[
                                                                  item.jobId
                                                                ]
                                                                  ? jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ].systems
                                                                      .find(
                                                                        (s) =>
                                                                          s.system_id ===
                                                                          item.systemId,
                                                                      )
                                                                      ?.phases?.map(
                                                                        (
                                                                          p,
                                                                        ) => ({
                                                                          value:
                                                                            p.phase_id,
                                                                          label:
                                                                            p.phase_name,
                                                                        }),
                                                                      ) || []
                                                                  : []
                                                              }
                                                              value={
                                                                item.jobId &&
                                                                item.systemId &&
                                                                jobSystemsPhasesMap[
                                                                  item.jobId
                                                                ] &&
                                                                item.phaseId
                                                                  ? jobSystemsPhasesMap[
                                                                      item.jobId
                                                                    ].systems
                                                                      .find(
                                                                        (s) =>
                                                                          s.system_id ===
                                                                          item.systemId,
                                                                      )
                                                                      ?.phases?.map(
                                                                        (
                                                                          p,
                                                                        ) => ({
                                                                          value:
                                                                            p.phase_id,
                                                                          label:
                                                                            p.phase_name,
                                                                        }),
                                                                      )
                                                                      ?.find(
                                                                        (o) =>
                                                                          o.value ===
                                                                          item.phaseId,
                                                                      )
                                                                  : null
                                                              }
                                                              onChange={(opt) =>
                                                                setFieldValue(
                                                                  `items.${originalIndex}.phaseId`,
                                                                  opt?.value ||
                                                                    null,
                                                                )
                                                              }
                                                              isClearable
                                                              isDisabled={
                                                                !item.systemId
                                                              }
                                                              placeholder={
                                                                item.systemId
                                                                  ? "Select phase"
                                                                  : "First select a system"
                                                              }
                                                              menuPortalTarget={
                                                                document.body
                                                              }
                                                              menuPosition="fixed"
                                                              menuPlacement="auto"
                                                              styles={{
                                                                container: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  width:
                                                                    "200px",
                                                                }),
                                                                option: (
                                                                  b,
                                                                  s,
                                                                ) => ({
                                                                  ...b,
                                                                  backgroundColor:
                                                                    s.isSelected
                                                                      ? "#007bff"
                                                                      : s.isFocused
                                                                        ? "#e6f7ff"
                                                                        : "#fff",
                                                                  color: "#333",
                                                                  fontSize:
                                                                    "0.8rem",
                                                                }),
                                                                menuPortal: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  zIndex: 9999,
                                                                }),
                                                                menu: (b) => ({
                                                                  ...b,
                                                                  zIndex: 9999,
                                                                }),
                                                                control: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  color:
                                                                    "#5e667b",
                                                                }),
                                                                placeholder: (
                                                                  b,
                                                                ) => ({
                                                                  ...b,
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                  overflow:
                                                                    "hidden",
                                                                  textOverflow:
                                                                    "ellipsis",
                                                                }),
                                                              }}
                                                            />
                                                            <ErrorMessage
                                                              name={`items.${originalIndex}.phaseId`}
                                                              component="div"
                                                              className="text-danger"
                                                            />
                                                          </td>
                                                          <td>
                                                            <Form.Control
                                                              readOnly
                                                              type="text"
                                                              value={
                                                                optionsJob.find(
                                                                  (o) =>
                                                                    o.value ===
                                                                    values
                                                                      .items[
                                                                      originalIndex
                                                                    ]?.jobId,
                                                                )?.siteName ||
                                                                ""
                                                              }
                                                              style={{
                                                                resize: "none",
                                                                width: "auto",
                                                                fontSize:
                                                                  "0.8rem",
                                                              }}
                                                            />
                                                          </td>
                                                          <td
                                                            style={{
                                                              textWrap: "unset",
                                                            }}
                                                          >
                                                            <Link
                                                              className="btn btn-sm btn-icon btn-success"
                                                              onClick={(e) => {
                                                                e.preventDefault();
                                                                handleView(
                                                                  e,
                                                                  values.items[
                                                                    originalIndex
                                                                  ],
                                                                  values.items
                                                                    .map(
                                                                      (
                                                                        it,
                                                                        i,
                                                                      ) =>
                                                                        i !==
                                                                        originalIndex
                                                                          ? it.productId
                                                                          : null,
                                                                    )
                                                                    .filter(
                                                                      Boolean,
                                                                    ),
                                                                  originalIndex,
                                                                  values,
                                                                );
                                                              }}
                                                              title="View"
                                                            >
                                                              <span className="btn-inner">
                                                                <IoEyeOutline
                                                                  style={{
                                                                    width:
                                                                      "20px",
                                                                    height:
                                                                      "20px",
                                                                  }}
                                                                />
                                                              </span>
                                                            </Link>{" "}
                                                            <OverlayTrigger
                                                              placement="top"
                                                              overlay={
                                                                <BSTooltip
                                                                  id={`tooltip-remove-${originalIndex}`}
                                                                  className="custom-contact-tooltip"
                                                                >
                                                                  Remove
                                                                </BSTooltip>
                                                              }
                                                            >
                                                              <span
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                  display:
                                                                    "inline-block",
                                                                }}
                                                              >
                                                                <IconButton
                                                                  size="medium"
                                                                  color="error"
                                                                  onClick={() => {
                                                                    arrayHelpers.remove(
                                                                      originalIndex,
                                                                    );
                                                                    setSelectedAddedProducts(
                                                                      (prev) =>
                                                                        prev.filter(
                                                                          (p) =>
                                                                            p.productId !==
                                                                            item.productId,
                                                                        ),
                                                                    );
                                                                  }}
                                                                >
                                                                  <CancelIcon fontSize="medium" />
                                                                </IconButton>
                                                              </span>
                                                            </OverlayTrigger>
                                                          </td>
                                                        </tr>
                                                      );
                                                    },
                                                  )}
                                                  <tr>
                                                    {paginatedItems.length >
                                                      0 &&
                                                      showLoadMore && (
                                                        <div
                                                          style={{
                                                            position: "sticky",
                                                            bottom: "0",
                                                            left: "40%",
                                                            width: "100%",
                                                            display: "flex",
                                                            justifyContent:
                                                              "center",
                                                            backgroundColor:
                                                              "white",
                                                            padding: "1rem 0",
                                                            zIndex: 10,
                                                          }}
                                                        >
                                                          <button
                                                            type="button"
                                                            className="btn btn-outline-primary btn-lg px-4 py-2 mb-2"
                                                            onClick={
                                                              loadMoreItems
                                                            }
                                                            disabled={
                                                              isLoadingMoreSelectedProduct
                                                            }
                                                            style={{
                                                              borderRadius:
                                                                "20px",
                                                              fontWeight: "400",
                                                              fontSize: "14px",
                                                              minWidth: "150px",
                                                              transition:
                                                                "all 0.3s ease",
                                                            }}
                                                          >
                                                            {isLoadingMoreSelectedProduct ? (
                                                              <>
                                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                                Loading...
                                                              </>
                                                            ) : (
                                                              <>
                                                                <i className="fas fa-plus-circle me-2"></i>
                                                                Load More
                                                              </>
                                                            )}
                                                          </button>
                                                        </div>
                                                      )}
                                                    {(values.items.length ===
                                                      0 ||
                                                      (paginatedItems.length ===
                                                        0 &&
                                                        searchSelectedProducts.trim()
                                                          .length > 0)) && (
                                                      <div
                                                        style={{
                                                          position: "sticky",
                                                          bottom: "0",
                                                          left: "30%",
                                                          width: "100%",
                                                          display: "flex",
                                                          justifyContent:
                                                            "center",
                                                          backgroundColor:
                                                            "white",
                                                          padding: "3rem 0",
                                                          zIndex: 10,
                                                        }}
                                                      >
                                                        <div className="align-items-center text-muted">
                                                          <i className="fas fa-search fa-3x mb-3 opacity-50"></i>
                                                          {values?.items
                                                            ?.length === 0 ? (
                                                            <>
                                                              No products have
                                                              been added yet.{" "}
                                                              <a
                                                                style={{
                                                                  color:
                                                                    "#007bff",
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  setActivePanel(
                                                                    "addProducts",
                                                                  )
                                                                }
                                                              >
                                                                Add some
                                                                products
                                                              </a>{" "}
                                                              to continue.
                                                            </>
                                                          ) : (
                                                            <p className="mb-0">
                                                              No products found.
                                                              Try adjusting your
                                                              search criteria.
                                                            </p>
                                                          )}
                                                        </div>
                                                      </div>
                                                    )}
                                                  </tr>
                                                </>
                                              );
                                            }}
                                          />
                                        </tbody>
                                      </Table>
                                    </div>
                                  </Box>
                                </Card.Body>
                                </Card>
                              </Col>

                              {!isMobile && isRightPanelOpen && (
                                <Tooltip
                                  title="Drag left or right to resize"
                                  placement="top"
                                  arrow
                                >
                                  <div
                                    onMouseDown={startResizing}
                                    style={{
                                      width: "16px",
                                      cursor: "col-resize",
                                      zIndex: 10,
                                      flex: "0 0 auto",
                                      position: "relative",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      background: isResizing
                                        ? "rgba(0,123,255,0.05)"
                                        : "transparent",
                                      transition: "background 0.3s",
                                    }}
                                    className="resizer-handle"
                                  >
                                    <div
                                      style={{
                                        width: "1px",
                                        height: "78%",
                                        borderLeft: isResizing
                                          ? "2px solid #007bff"
                                          : "2px dotted #adb5bd",
                                        opacity: isResizing ? 1 : 0.6,
                                        transition: "all 0.3s",
                                        position: "absolute",
                                      }}
                                    />
                                    <div
                                      style={{
                                        width: "16px",
                                        height: "40px",
                                        borderRadius: "4px",
                                        background: isResizing
                                          ? "#007bff"
                                          : "#fff",
                                        border: isResizing
                                          ? "1px solid #007bff"
                                          : "1px solid #adb5bd",
                                        zIndex: 11,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-evenly",
                                        alignItems: "center",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                        transition: "all 0.3s",
                                      }}
                                    >
                                      {[0, 1, 2].map((i) => (
                                        <div
                                          key={i}
                                          style={{
                                            width: "2px",
                                            height: "2px",
                                            borderRadius: "50%",
                                            background: isResizing
                                              ? "#fff"
                                              : "#adb5bd",
                                          }}
                                        />
                                      ))}
                                    </div>
                                  </div>
                                </Tooltip>
                              )}

                              <Col
                                md="auto"
                                sm={12}
                                className="m-0 p-0"
                                style={{
                                  width: isMobile
                                    ? isRightPanelOpen
                                      ? "100%"
                                      : "0%"
                                    : isRightPanelOpen
                                      ? `calc(${100 - leftWidth}% - 5px)`
                                      : "0%",
                                  height: isRightPanelOpen ? "auto" : "0px",
                                  opacity: isRightPanelOpen ? 1 : 0,
                                  transition: isResizing
                                    ? "none"
                                    : "width 0.5s ease-in-out, opacity 0.3s ease-in-out",
                                  overflow: "hidden",
                                  visibility: isRightPanelOpen
                                    ? "visible"
                                    : "hidden",
                                  maxWidth: isMobile
                                    ? "100%"
                                    : isRightPanelOpen
                                      ? `calc(${100 - leftWidth}% - 5px)`
                                      : "0%",
                                  flex: isMobile ? "1 1 auto" : "0 0 auto",
                                }}
                              >
                                <div
                                  style={{
                                    opacity: isRightPanelOpen ? 1 : 0,
                                    transform: isRightPanelOpen
                                      ? "translateX(0)"
                                      : "translateX(20px)",
                                    transition:
                                      "opacity 0.4s ease-in-out, transform 0.4s ease-in-out",
                                  }}
                                >
                                  <Card.Header className="d-flex justify-content-between align-items-start ps-0 pt-2 pb-3 flex-wrap gap-2">
                                    <div className="header-title">
                                      <h5 className="card-title">
                                        General Products
                                      </h5>
                                      <p className="card-title">
                                        Drag product from here into the product request form
                                      </p>
                                    </div>
                                    <Col
                                      md={5}
                                      className="d-flex flex-row justify-content-end align-items-center mb-0"
                                    >
                                      <Form.Label
                                        className="text-nowrap me-2 mt-1"
                                        style={{ fontSize: "16px" }}
                                      >
                                        Filter by{" "}
                                      </Form.Label>
                                      <Select
                                        options={optionsVendor}
                                        value={optionsVendor.find(
                                          (o) => o.value === spSelectedVendorId,
                                        )}
                                        onChange={(option) => {
                                          setSpSelectedVendorId(
                                            option?.value || "all",
                                          );
                                        }}
                                        isClearable
                                        placeholder="Select Vendor"
                                        styles={{
                                          container: (b) => ({
                                            ...b,
                                            width: "100%",
                                          }),
                                          option: (b, s) => ({
                                            ...b,
                                            backgroundColor: s.isSelected
                                              ? "#007bff"
                                              : s.isFocused
                                                ? "#e6f7ff"
                                                : "#fff",
                                            color: "#333",
                                            fontSize: "0.8rem",
                                          }),
                                          menuPortal: (b) => ({
                                            ...b,
                                            zIndex: 9999,
                                          }),
                                          menu: (b) => ({
                                            ...b,
                                            zIndex: 9999,
                                          }),
                                        }}
                                      />
                                    </Col>
                                  </Card.Header>


                                  <Card.Body className="ps-0 pe-0 pt-0">
                                    <Box
                                      sx={{
                                        width: "100%",
                                        overflow: "visible",
                                        "& .MuiToolbar-root": {
                                          minHeight: "auto !important",
                                          py: "8px",
                                        },
                                        marginTop: "5.5rem"
                                      }}
                                    >
                                      <MaterialReactTable
                                        table={tableAddProducts}
                                      />
                                    </Box>
                                     <div className="d-flex justify-content-end mt-4">
                                     </div>
                                  </Card.Body>
                                </div>
                              </Col>
                            </Row>

                            <div className="d-flex flex-wrap flex-md-nowrap justify-content-end gap-1 gap-md-2 mt-4">
                              <Button
                                type="button"
                                className="me-2 px-3 px-md-4"
                                variant="btn btn-light"
                                onClick={() => {
                                  resetForm();
                                  setFieldValue("items", []);
                                  setSelectedAddedProducts([]);
                                  setErrors({});
                                  setInactiveProductErrors([]);
                                  setClickSubmitProduct(false);
                                  setSearchSelectedProducts("");
                                  setBulkJobId(null);
                                  setBulkSystemId(null);
                                  setBulkPhaseId(null);
                                  setBulkSystemOptions([]);
                                  setBulkPhaseOptions([]);
                                }}
                              >
                                Reset
                              </Button>

                              {decodedToken?.roles.some(
                                (r) =>
                                  r.role_type === roleTypes.ADMIN ||
                                  r.role_type === roleTypes.PURCHASING ||
                                  r.role_type === roleTypes.SUPPLIER,
                              ) && orderHasCreatePermission ? (
                                <>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <BSTooltip
                                        id="tooltip-create-pr"
                                        className="custom-contact-tooltip"
                                      >
                                        Create product request for later
                                      </BSTooltip>
                                    }
                                  >
                                    <Button
                                      type="button"
                                      disabled={isSubmitting}
                                      variant="btn btn-primary"
                                      className="me-2 px-3 px-md-4"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedAction("pr");
                                        setShowPONumber(false);
                                        showPONumberRef.current = false;
                                        setClickSubmitProduct(true);
                                        setErrors((prev) => {
                                          const { poNumber, ...rest } = prev;
                                          return rest;
                                        });
                                        handleSubmit();
                                      }}
                                    >
                                      Create PR
                                    </Button>
                                  </OverlayTrigger>
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <BSTooltip
                                        id="tooltip-create-order"
                                        className="custom-contact-tooltip"
                                      >
                                        Create order immediately
                                      </BSTooltip>
                                    }
                                  >
                                    <Button
                                      type="button"
                                      disabled={isSubmitting}
                                      variant="btn btn-success"
                                      className="me-2 px-3 px-md-4"
                                      onClick={async (e) => {
                                        e.preventDefault();
                                        setSelectedAction("order");
                                        setClickSubmitProduct(true);
                                        const shouldShowPO = !showPONumber;
                                        if (shouldShowPO) {
                                          setShowPONumber(true);
                                          showPONumberRef.current = true;
                                        }
                                        const fieldsToTouch = {
                                          date: true,
                                          warehouseId: true,
                                          shipTo: true,
                                          poNumber: true,
                                          vendorId: true,
                                        };
                                        if (values.items?.length > 0)
                                          fieldsToTouch.items =
                                            values.items.map(() => ({
                                              productId: true,
                                              manufacturerId: true,
                                              jobId: true,
                                              systemId: true,
                                              phaseId: true,
                                              quantity: true,
                                              rate: true,
                                              amount: true,
                                            }));
                                        else fieldsToTouch.items = true;
                                        setTouched(
                                          { ...touched, ...fieldsToTouch },
                                          false,
                                        );
                                        if (shouldShowPO)
                                          await new Promise((r) =>
                                            setTimeout(r, 100),
                                          );
                                        let formErrors = await validateForm();
                                        if (shouldShowPO || showPONumber) {
                                          const newErrors = { ...formErrors };
                                          let hasOrderErrors = false;
                                          if (
                                            !values.poNumber ||
                                            values.poNumber.trim() === ""
                                          ) {
                                            newErrors.poNumber =
                                              "PO # is required";
                                            hasOrderErrors = true;
                                          } else if (
                                            values.poNumber.trim().length < 3
                                          ) {
                                            newErrors.poNumber =
                                              "PO # must be at least 3 characters";
                                            hasOrderErrors = true;
                                          } else if (
                                            !/^[A-Za-z0-9-]+$/.test(
                                              values.poNumber.trim(),
                                            )
                                          ) {
                                            newErrors.poNumber =
                                              "PO # can only contain alphanumeric characters and hyphens";
                                            hasOrderErrors = true;
                                          }
                                          if (!values.vendorId) {
                                            newErrors.vendorId =
                                              "Vendor is required";
                                            hasOrderErrors = true;
                                          }
                                          if (hasOrderErrors) {
                                            setErrors(newErrors);
                                            return;
                                          }
                                          formErrors = newErrors;
                                        }
                                        if (
                                          formErrors &&
                                          Object.keys(formErrors).length > 0
                                        ) {
                                          setErrors(formErrors);
                                          return;
                                        }
                                        setClickSubmitProduct(true);
                                        setTimeout(() => handleSubmit(), 0);
                                      }}
                                    >
                                      {showPONumber &&
                                      !isSubmitting &&
                                      selectedAction === "order"
                                        ? "Create Order"
                                        : isSubmitting &&
                                            showPONumber &&
                                            selectedAction === "order"
                                          ? "Creating Order..."
                                          : "Create Order"}
                                    </Button>
                                  </OverlayTrigger>
                                </>
                              ) : (
                                <Button
                                  type="button"
                                  disabled={isSubmitting}
                                  variant="btn btn-primary"
                                  className="me-2 px-3 px-md-4"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedAction("pr");
                                    setShowPONumber(false);
                                    showPONumberRef.current = false;
                                    setClickSubmitProduct(true);
                                    setErrors((prev) => {
                                      const { poNumber, ...rest } = prev;
                                      return rest;
                                    });
                                    handleSubmit();
                                  }}
                                >
                                  Create PR
                                </Button>
                              )}

                              <Button
                                type="button"
                                className="px-3 px-md-4"
                                variant="btn btn-danger"
                                onClick={() =>
                                  navigate(
                                    "/dashboard/app/product-request-list",
                                  )
                                }
                              >
                                Cancel
                              </Button>
                            </div>
                          </>
                        ) : (
                          loader && <FadeLoaderComponent />
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Form>
            );
          }}
        </Formik>
      </div>
    </>
  );
};

export default ProductRequestAdd;
